<template>
  <div :class="`${$screen.width <= 576 ? 'container-mobile' : fillClassContainer}`" class="animated fadeIn clearfix px-0 pt-2 pb-4">
    <div class="form">
      <!-- <pre>{{ contract }}</pre> -->
      <!-- Work details -->
      <div v-if="$screen.width > 576" class="card-collapsible px-0">
        <div class="header-card-collapsible d-flex flex-row align-items-center cursor-pointer" @click="handleClickHeader('work-details')">
          <div class="title w-90">
            <b-icon icon="file-earmark-person" style="color: rgba(6, 38, 62, 0.84)" /><span class="ml-3">{{ FormMSG(129, 'Work details') }}</span>
          </div>
          <div class="cursor-pointer d-flex justify-content-end w-10">
            <component
              :is="getLucideIcon(ICONS.CHEVRON_DOWN.name)"
              v-if="!configAccordion['work-details'].isVisible"
              :color="ICONS.CHEVRON_DOWN.color"
              :size="22"
            />
            <component :is="getLucideIcon(ICONS.CHEVRON_UP.name)" v-if="configAccordion['work-details'].isVisible" :color="ICONS.CHEVRON_UP.color" :size="22" />
          </div>
        </div>
      </div>
      <b-collapse :visible="configAccordion['work-details'].isVisible">
        <div :class="`${$screen.width > 576 ? 'content-card-collapsible' : ''}`">
          <!-- Begin Work info -->
          <div v-if="$screen.width <= 576" class="card-collapsible px-0">
            <div
              class="header-card-collapsible inside d-flex flex-row align-items-center bgc-grey-light cursor-pointer"
              @click="handleClickHeader('work-info')"
            >
              <div class="title w-90">
                <b-icon icon="file-earmark-check" style="color: #06263e" font-scale="1.2" />
                <div class="fz-1-35 ml-3">{{ FormMSG(306, 'Work info') }}</div>
              </div>
              <div class="cursor-pointer d-flex justify-content-end w-10">
                <component
                  :is="getLucideIcon(ICONS.CHEVRON_DOWN.name)"
                  v-if="!configAccordion['work-info'].isVisible"
                  :color="ICONS.CHEVRON_DOWN.color"
                  :size="22"
                />
                <component
                  :is="getLucideIcon(ICONS.CHEVRON_UP.name)"
                  v-if="configAccordion['work-info'].isVisible"
                  :color="ICONS.CHEVRON_UP.color"
                  :size="22"
                />
              </div>
            </div>
          </div>
          <b-collapse :visible="configAccordion['work-info'].isVisible">
            <div :class="`${$screen.width > 576 ? '' : 'content-card-collapsible inside'}`">
              <b-row>
                <b-col sm="12" md="12" :lg="`${showCCN2642CDDU() ? 4 : 6}`" :xl="`${showCCN2642CDDU() ? 4 : 6}`">
                  <b-form-group :label="FormMSG(41, 'Union')">
                    <b-form-select
                      v-model="contract.timeManagementType"
                      :disabled="isEditable() === false"
                      :options="optionsForTimeManagementType"
                      @change="handleManagementType"
                    />
                  </b-form-group>
                </b-col>
                <b-col v-if="showStandard()" sm="12" md="12" lg="6" xl="6">
                  <b-form-group :label="FormMSG(88, 'Default day type')">
                    <b-form-select v-model="contract.defaultDayType" :disabled="isEditable() === false" :options="optionsForDefaultDayType" />
                    <!-- @change="getStandardPayCodeTitle" -->
                  </b-form-group>
                </b-col>
                <b-col v-else-if="showCCNAnnex()" sm="12" md="12" lg="6" xl="6">
                  <b-form-group :label="FormMSG(42, 'Week type')" label-for="timeManagementType">
                    <b-form-select v-model="contract.workSixDays" :disabled="isEditable() === false" :options="optionsForNumDays" />
                    <!-- @change="computeSMG()" -->
                  </b-form-group>
                </b-col>
                <div v-else-if="showCCN2642CDDU()" class="d-flex flex-row col-8 px-0">
                  <b-col sm="12" md="12" lg="6" xl="6">
                    <b-form-group :label="FormMSG(324, 'Work Type - CCN 2642')">
                      <b-form-select v-model="contract.workSixDays" :disabled="isEditable() === false" :options="cnn2642Options" @change="handleCcn2642" />
                    </b-form-group>
                  </b-col>
                  <b-col sm="12" md="12" lg="6" xl="6">
                    <input-currency
                      v-model="contract.weeklyFiveDaysRefSalary"
                      :disabled="isEditable() === false"
                      :label="`${FormMSG(327, '35h week reference salary')}`"
                      :model-name="'contract.weeklyFiveDaysRefSalary'"
                      :min="0"
                      :min-fraction-digits="0"
                      :max-fraction-digits="numberOfDecimals"
                      :has-element-to-append="true"
                      :element-append-choice="ELEMENT_APPEND_CHOICE.CURRENCY"
                      @input-number:value="onHandledNumber"
                      @change="handleWeeklyRefSalary"
                    />
                  </b-col>
                </div>
                <b-col v-else-if="showCCN2642CDICDD()" sm="12" md="12" lg="6" xl="6">
                  <input-currency
                    v-model="contract.cdiMonthlyReferenceSalary"
                    :disabled="isEditable() === false"
                    :label="`${FormMSG(328, 'Monthly reference salary')}`"
                    :model-name="'contract.cdiMonthlyReferenceSalary'"
                    :min="0"
                    :min-fraction-digits="0"
                    :max-fraction-digits="numberOfDecimals"
                    :has-element-to-append="true"
                    :element-append-choice="ELEMENT_APPEND_CHOICE.CURRENCY"
                    @input-number:value="onHandledNumber"
                    @change="handleMonthlyRefSalary"
                  />
                </b-col>
              </b-row>
            </div>
          </b-collapse>
          <!-- Begin Work info -->
          <!-- Begin Main details -->
          <div class="card-collapsible px-0" :class="`${$screen.width > 576 ? 'mt-1' : 'mt-4'}`">
            <div
              class="header-card-collapsible inside d-flex flex-row align-items-center bgc-grey-light cursor-pointer"
              @click="handleClickHeader('main-details')"
            >
              <div class="title w-90">
                <component :is="getLucideIcon(ICONS.LIST_CHECK.name)" :color="ICONS.LIST_CHECK.color" :size="22" />
                <div class="fz-1-35 ml-3">
                  {{ FormMSG(130, 'Main details') }}
                </div>
              </div>
              <div class="cursor-pointer d-flex justify-content-end w-10">
                <component
                  :is="getLucideIcon(ICONS.CHEVRON_DOWN.name)"
                  v-if="!configAccordion['main-details'].isVisible"
                  :color="ICONS.CHEVRON_DOWN.color"
                  :size="22"
                />
                <component
                  :is="getLucideIcon(ICONS.CHEVRON_UP.name)"
                  v-if="configAccordion['main-details'].isVisible"
                  :color="ICONS.CHEVRON_UP.color"
                  :size="22"
                />
              </div>
            </div>
          </div>
          <b-collapse :visible="configAccordion['main-details'].isVisible">
            <div class="content-card-collapsible inside">
              <div v-if="showStandard()" class="px-0">
                <b-row>
                  <b-col
                    :sm="`${$screen.width <= 576 ? 0 : 12}`"
                    :md="`${$screen.width <= 576 ? 0 : 12}`"
                    :lg="`${$screen.width <= 576 ? 0 : 3}`"
                    :xl="`${$screen.width <= 576 ? 0 : 3}`"
                    :cols="`${$screen.width <= 576 ? 6 : 0}`"
                  >
                    <!-- <pre>hourlyRate: {{ contract.hourlyRate }}</pre> -->
                    <input-currency
                      v-model="contract.hourlyRate"
                      :disabled="isEditable() === false"
                      :label="`${$screen.width <= 576 ? FormMSG(89, 'Hourly rate') : FormMSG(13, 'Hourly rate')}`"
                      :model-name="'contract.hourlyRate'"
                      :min="0"
                      :min-fraction-digits="0"
                      :max-fraction-digits="numberOfDecimals"
                      :has-element-to-append="true"
                      :element-append-choice="ELEMENT_APPEND_CHOICE.CURRENCY"
                      @input-number:value="onHandledNumber"
                      @change="computeSMG($event)"
                    />
                  </b-col>
                  <b-col
                    :sm="`${$screen.width <= 576 ? 0 : 12}`"
                    :md="`${$screen.width <= 576 ? 0 : 12}`"
                    :lg="`${$screen.width <= 576 ? 0 : 3}`"
                    :xl="`${$screen.width <= 576 ? 0 : 3}`"
                    :cols="`${$screen.width <= 576 ? 6 : 0}`"
                  >
                    <input-currency
                      v-model="contract.dailyRate"
                      :disabled="isEditable() === false"
                      :label="`${$screen.width <= 576 ? FormMSG(11, 'Daily Rate') : FormMSG(90, 'Daily rate')}`"
                      :model-name="'contract.dailyRate'"
                      :min="0"
                      :min-fraction-digits="0"
                      :max-fraction-digits="numberOfDecimals"
                      :has-element-to-append="true"
                      :element-append-choice="ELEMENT_APPEND_CHOICE.CURRENCY"
                      @input-number:value="onHandledNumber"
                    />
                  </b-col>
                  <b-col
                    :sm="`${$screen.width <= 576 ? 0 : 12}`"
                    :md="`${$screen.width <= 576 ? 0 : 12}`"
                    :lg="`${$screen.width <= 576 ? 0 : 3}`"
                    :xl="`${$screen.width <= 576 ? 0 : 3}`"
                    :cols="`${$screen.width <= 576 ? 6 : 0}`"
                  >
                    <input-currency
                      v-model="contract.weeklyFiveDaysMinimumSalary"
                      :disabled="isEditable() === false"
                      :label="`${$screen.width <= 576 ? FormMSG(310, 'Weekly rate') : FormMSG(123, 'Weekly rate')}`"
                      :model-name="'contract.weeklyFiveDaysMinimumSalary'"
                      :min="0"
                      :min-fraction-digits="0"
                      :max-fraction-digits="numberOfDecimals"
                      :has-element-to-append="true"
                      :element-append-choice="ELEMENT_APPEND_CHOICE.CURRENCY"
                      @input-number:value="onHandledNumber"
                      @change="computeHourlyRate(contract.weeklyFiveDaysMinimumSalary)"
                    />
                  </b-col>
                  <b-col
                    :sm="`${$screen.width <= 576 ? 0 : 12}`"
                    :md="`${$screen.width <= 576 ? 0 : 12}`"
                    :lg="`${$screen.width <= 576 ? 0 : 3}`"
                    :xl="`${$screen.width <= 576 ? 0 : 3}`"
                    :cols="`${$screen.width <= 576 ? 6 : 0}`"
                  >
                    <input-currency
                      v-model="contract.monthlyRate"
                      :disabled="isEditable() === false || contract.useMonthlyRate === false"
                      :label="`${$screen.width <= 576 ? FormMSG(311, 'Monthly rate') : FormMSG(303, 'Monthly rate')}`"
                      :model-name="'contract.monthlyRate'"
                      :min="0"
                      :min-fraction-digits="0"
                      :max-fraction-digits="numberOfDecimals"
                      :has-element-to-append="true"
                      :element-append-choice="ELEMENT_APPEND_CHOICE.CURRENCY"
                      @input-number:value="onHandledNumber"
                    />
                  </b-col>
                </b-row>
                <b-row>
                  <b-col
                    :sm="`${$screen.width <= 576 ? 0 : 12}`"
                    :md="`${$screen.width <= 576 ? 0 : 12}`"
                    :lg="`${$screen.width <= 576 ? 0 : 4}`"
                    :xl="`${$screen.width <= 576 ? 0 : 4}`"
                    :cols="`${$screen.width <= 576 ? 6 : 0}`"
                  >
                    <b-form-group v-uni-for="'minDay'" :label="`${$screen.width <= 576 ? FormMSG(24, 'Daily Work') : FormMSG(92, 'Daily hours')}`">
                      <input-date-time-picker
                        :label="`${$screen.width <= 576 ? FormMSG(24, 'Daily Work') : FormMSG(92, 'Daily hours')}`"
                        :uiid="'minDay'"
                        :type="'text'"
                        :placeholder="'hh:mm'"
                        :is-submitted="isSubmitted"
                        :item="contract.totMinPerDayStr"
                        :nb-hour="rangeHour[WORKTYPE.daily]"
                        :nb-minute="rangeMinute[WORKTYPE.daily]"
                        :is-editable="() => isEditable()"
                        :field-name="'totMinPerDay'"
                        :work-type="WORKTYPE.daily"
                        @change="handleChangeHourMin"
                      />
                      <!-- <div
												v-if="isSubmitted && !$v.contract.totMinPerDayStr.hourMinuteValid && contract.calculateSalary"
												class="invalid-feedback"
											>
												{{ FormMSG(151, 'Please, enter hours and minutes valid. (e.g: 45:00)') }}
											</div> -->
                    </b-form-group>
                  </b-col>
                  <b-col
                    :sm="`${$screen.width <= 576 ? 0 : 12}`"
                    :md="`${$screen.width <= 576 ? 0 : 12}`"
                    :lg="`${$screen.width <= 576 ? 0 : 4}`"
                    :xl="`${$screen.width <= 576 ? 0 : 4}`"
                    :cols="`${$screen.width <= 576 ? 6 : 0}`"
                  >
                    <b-form-group v-uni-for="'minWeek'" :label="`${$screen.width <= 576 ? FormMSG(25, 'Weekly Work') : FormMSG(91, 'Weekly hours')}`">
                      <input-date-time-picker
                        :label="`${$screen.width <= 576 ? FormMSG(25, 'Weekly Work') : FormMSG(91, 'Weekly hours')}`"
                        :uiid="'minWeek'"
                        :type="'text'"
                        :placeholder="'hh:mm'"
                        :is-submitted="isSubmitted"
                        :item="contract.totMinPerWeekStr"
                        :nb-hour="rangeHour[WORKTYPE.weekly]"
                        :nb-minute="rangeMinute[WORKTYPE.weekly]"
                        :is-editable="() => isEditable()"
                        :field-name="'totMinPerWeek'"
                        :work-type="WORKTYPE.weekly"
                        @change="handleChangeHourMin"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col sm="12" md="12" lg="4" xl="4">
                    <b-form-group
                      v-uni-for="'minDayForCont'"
                      :label="`${$screen.width <= 576 ? FormMSG(312, 'Daily Work for continuous day') : FormMSG(295, 'Daily hours for continuous day')}`"
                    >
                      <input-date-time-picker
                        :label="`${$screen.width <= 576 ? FormMSG(312, 'Daily Work for continuous day') : FormMSG(295, 'Daily hours for continuous day')}`"
                        :uiid="'minDayForCont'"
                        :type="'text'"
                        :placeholder="'hh:mm'"
                        :is-submitted="isSubmitted"
                        :item="contract.totMinPerDayForContDayStr"
                        :nb-hour="rangeHour[WORKTYPE.daily]"
                        :nb-minute="rangeMinute[WORKTYPE.daily]"
                        :is-editable="() => isEditable()"
                        :field-name="'totMinPerDayForContDay'"
                        :work-type="WORKTYPE.daily"
                        @change="handleChangeHourMin"
                      />
                      <!-- <div
												v-if="isSubmitted && !$v.contract.totMinPerDayForContDayStr.hourMinuteValid && contract.calculateSalary"
												class="invalid-feedback"
											>
												{{ FormMSG(151, 'Please, enter hours and minutes valid. (e.g: 45:00)') }}
											</div> -->
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col
                    :sm="`${$screen.width <= 576 ? 0 : 6}`"
                    :md="`${$screen.width <= 576 ? 0 : 6}`"
                    :lg="`${$screen.width <= 576 ? 0 : 4}`"
                    :xl="`${$screen.width <= 576 ? 0 : 4}`"
                    :cols="`${$screen.width <= 576 ? 6 : 0}`"
                  >
                    <b-form-group
                      v-uni-for="'minHourGuarantee'"
                      :label="`${$screen.width > 576 ? FormMSG(167, 'Minimum hour guarantee') : FormMSG(307, 'Min hour guarantee')}`"
                    >
                      <input-date-time-picker
                        :label="`${$screen.width > 576 ? FormMSG(167, 'Minimum hour guarantee') : FormMSG(307, 'Min hour guarantee')}`"
                        :uiid="'minHourGuarantee'"
                        :type="'text'"
                        :placeholder="'hh:mm'"
                        :is-submitted="isSubmitted"
                        :item="contract.minimumHourGuaranteedStr"
                        :nb-hour="rangeHour[contract.minimumHourGuaranteedType === 0 ? WORKTYPE.daily : WORKTYPE.weekly]"
                        :nb-minute="rangeMinute[contract.minimumHourGuaranteedType === 0 ? WORKTYPE.daily : WORKTYPE.weekly]"
                        :is-editable="() => isEditable()"
                        :field-name="'minimumHourGuaranteed'"
                        :work-type="contract.minimumHourGuaranteedType === 0 ? WORKTYPE.daily : WORKTYPE.weekly"
                        @change="handleChangeHourMin"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col
                    :sm="`${$screen.width <= 576 ? 0 : 6}`"
                    :md="`${$screen.width <= 576 ? 0 : 6}`"
                    :lg="`${$screen.width <= 576 ? 0 : 4}`"
                    :xl="`${$screen.width <= 576 ? 0 : 4}`"
                    :cols="`${$screen.width <= 576 ? 6 : 0}`"
                  >
                    <label for="minHourGuaranteeType">&nbsp;</label>
                    <b-input-group>
                      <b-form-select
                        v-model="contract.minimumHourGuaranteedType"
                        :disabled="isEditable() === false"
                        :options="partialPeriodicalOptions"
                        @change="handleGuaranteedType"
                      />
                    </b-input-group>
                  </b-col>
                  <b-col sm="12" md="12" lg="4" xl="4">
                    <input-currency
                      v-model="contract.travelDailyRate"
                      :disabled="isEditable() === false"
                      :label="`${FormMSG(12, 'Travel rate ')}`"
                      :model-name="'contract.travelDailyRate'"
                      :min="0"
                      :min-fraction-digits="0"
                      :max-fraction-digits="numberOfDecimals"
                      :has-element-to-append="true"
                      :element-append-choice="ELEMENT_APPEND_CHOICE.CURRENCY"
                      @input-number:value="onHandledNumber"
                    />
                  </b-col>
                </b-row>
                <b-row v-if="showDefaultPayCode">
                  <b-col sm="12" md="12" lg="3" xl="3">
                    <b-form-group :label="FormMSG(320, 'Pay code daily rate')">
                      <payroll-code
                        :ref="generateTextId('baseSalary1PayCode')"
                        style-type="select"
                        :value="contract.baseSalary1PayCode"
                        @payroll-code:input="setPayroolCodeValue($event, 'baseSalary1PayCode')"
                        @payroll-code:reset="resetPayroolCodeValue($event, 'baseSalary1PayCode')"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col sm="12" md="12" lg="3" xl="3">
                    <b-form-group :label="FormMSG(321, 'Pay code continuous day')">
                      <payroll-code
                        :ref="generateTextId('baseSalary2PayCode')"
                        style-type="select"
                        :value="contract.baseSalary2PayCode"
                        @payroll-code:input="setPayroolCodeValue($event, 'baseSalary2PayCode')"
                        @payroll-code:reset="resetPayroolCodeValue($event, 'baseSalary2PayCode')"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col sm="12" md="12" lg="3" xl="3">
                    <b-form-group :label="FormMSG(322, 'Pay code travel day')">
                      <payroll-code
                        :ref="generateTextId('baseSalary3PayCode')"
                        style-type="select"
                        :value="contract.baseSalary3PayCode"
                        @payroll-code:input="setPayroolCodeValue($event, 'baseSalary3PayCode')"
                        @payroll-code:reset="resetPayroolCodeValue($event, 'baseSalary3PayCode')"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col sm="12" md="12" lg="3" xl="3">
                    <b-form-group :label="FormMSG(323, 'Pay code hourly rate')">
                      <payroll-code
                        :ref="generateTextId('baseSalary4PayCode')"
                        style-type="select"
                        :value="contract.baseSalary4PayCode"
                        @payroll-code:input="setPayroolCodeValue($event, 'baseSalary4PayCode')"
                        @payroll-code:reset="resetPayroolCodeValue($event, 'baseSalary4PayCode')"
                      />
                    </b-form-group>
                  </b-col>
                </b-row>
              </div>
              <div v-else-if="showCCNAnnex1()">
                <b-row>
                  <b-col sm="12" md="12" lg="4" xl="4">
                    <input-currency
                      v-model="contract.hourlyRate"
                      :disabled="isEditable() === false"
                      :label="`${$screen.width <= 576 ? FormMSG(59, 'Hourly rate') : FormMSG(308, 'Hourly rate')}`"
                      :model-name="'contract.hourlyRate'"
                      :min="0"
                      :min-fraction-digits="0"
                      :max-fraction-digits="numberOfDecimals"
                      :has-element-to-append="true"
                      :element-append-choice="ELEMENT_APPEND_CHOICE.CURRENCY"
                      @input-number:value="onHandledNumber"
                      @change="computeSMG($event)"
                    />
                  </b-col>
                  <b-col sm="12" md="12" lg="4" xl="4">
                    <input-currency
                      v-model="contract.weeklyBaseRefSalary"
                      disabled
                      :label="`${$screen.width <= 576 ? FormMSG(143, 'Minimum salary (SMG)') : FormMSG(61, 'Minimum salary (SMG)')}`"
                      :model-name="'contract.weeklyBaseRefSalary'"
                      :min="0"
                      :min-fraction-digits="0"
                      :max-fraction-digits="numberOfDecimals"
                      :has-element-to-append="true"
                      :element-append-choice="ELEMENT_APPEND_CHOICE.CURRENCY"
                      @input-number:value="onHandledNumber"
                    />
                    <input-currency
                      v-if="contract.workSixDays === 1"
                      v-model="contract.weeklyFiveDaysMinimumSalary"
                      disabled
                      :label="`${$screen.width <= 576 ? FormMSG(43, 'Five days minimum salary (SMG)') : FormMSG(62, '5 days minimum salary (SMG)')}`"
                      :model-name="'contract.weeklyFiveDaysMinimumSalary'"
                      :min="0"
                      :min-fraction-digits="0"
                      :max-fraction-digits="numberOfDecimals"
                      :has-element-to-append="true"
                      :element-append-choice="ELEMENT_APPEND_CHOICE.CURRENCY"
                      @input-number:value="onHandledNumber"
                    />
                    <input-currency
                      v-if="contract.workSixDays === 2"
                      v-model="contract.weeklySixDaysMinimumSalary"
                      disabled
                      :label="`${$screen.width <= 576 ? FormMSG(47, 'Six days minimum salary (SMG) €:') : FormMSG(65, '6 days minimum salary (SMG)')}`"
                      :model-name="'contract.weeklySixDaysMinimumSalary'"
                      :min="0"
                      :min-fraction-digits="0"
                      :max-fraction-digits="numberOfDecimals"
                      :has-element-to-append="true"
                      :element-append-choice="ELEMENT_APPEND_CHOICE.CURRENCY"
                      @input-number:value="onHandledNumber"
                      @change="computeHourlyRate(contract.weeklySixDaysMinimumSalary)"
                    />
                  </b-col>
                  <b-col sm="12" md="12" lg="4" xl="4">
                    <input-currency
                      v-model="contract.travelDailyRate"
                      :disabled="isEditable() === false"
                      :label="`${FormMSG(12, 'Travel rate ')}`"
                      :model-name="'contract.travelDailyRate'"
                      :min="0"
                      :min-fraction-digits="0"
                      :max-fraction-digits="numberOfDecimals"
                      :has-element-to-append="true"
                      :element-append-choice="ELEMENT_APPEND_CHOICE.CURRENCY"
                      @input-number:value="onHandledNumber"
                    />
                  </b-col>
                </b-row>
                <b-row>
                  <b-col sm="12" md="12" :lg="`${contract.workSixDays === 0 ? 6 : 4}`" :xl="`${contract.workSixDays === 0 ? 6 : 4}`">
                    <b-form-group v-uni-for="'minDay'" :label="`${$screen.width <= 576 ? FormMSG(24, 'Daily Work') : FormMSG(104, 'Daily hours')}`">
                      <input-date-time-picker
                        :label="`${$screen.width <= 576 ? FormMSG(24, 'Daily Work') : FormMSG(104, 'Daily hours')}`"
                        :uiid="'minDay'"
                        :type="'text'"
                        :placeholder="'hh:mm'"
                        :is-submitted="isSubmitted"
                        :item="contract.totMinPerDayStr"
                        :nb-hour="rangeHour[WORKTYPE.daily]"
                        :nb-minute="rangeMinute[WORKTYPE.daily]"
                        :is-editable="() => isEditable()"
                        :field-name="'totMinPerDay'"
                        :work-type="WORKTYPE.daily"
                        @change="handleChangeHourMin"
                      />
                      <!-- <div
												v-if="isSubmitted && !$v.contract.totMinPerDayStr.hourMinuteValid && contract.calculateSalary"
												class="invalid-feedback"
											>
												{{ FormMSG(151, 'Please, enter hours and minutes valid. (e.g: 45:00)') }}
											</div> -->
                    </b-form-group>
                  </b-col>
                  <b-col sm="12" md="12" :lg="`${contract.workSixDays === 0 ? 6 : 4}`" :xl="`${contract.workSixDays === 0 ? 6 : 4}`">
                    <b-form-group
                      v-if="contract.workSixDays === 0"
                      v-uni-for="'minWeek'"
                      :label="`${$screen.width <= 576 ? FormMSG(25, 'Weekly Work') : FormMSG(125, 'Weekly hours')}`"
                    >
                      <input-date-time-picker
                        :label="`${$screen.width <= 576 ? FormMSG(25, 'Weekly Work') : FormMSG(125, 'Weekly hours')}`"
                        :uiid="'minWeek'"
                        :type="'text'"
                        :placeholder="'hh:mm'"
                        :is-submitted="isSubmitted"
                        :item="contract.totMinPerWeekStr"
                        :nb-hour="rangeHour[WORKTYPE.weekly]"
                        :nb-minute="rangeMinute[WORKTYPE.weekly]"
                        :is-editable="() => isEditable()"
                        :field-name="'totMinPerWeek'"
                        :work-type="WORKTYPE.weekly"
                        @change="handleChangeHourMin"
                      />
                    </b-form-group>
                    <b-form-group v-if="contract.workSixDays === 1" v-uni-for="'fdeh'" :label="FormMSG(63, '5 days effective hours')">
                      <input-date-time-picker
                        :label="FormMSG(63, '5 days effective hours')"
                        :uiid="'fdeh'"
                        :type="'text'"
                        :placeholder="'hh:mm'"
                        :is-submitted="isSubmitted"
                        :item="contract.weeklyFiveDaysEffNumHoursStr"
                        :nb-hour="rangeHour[WORKTYPE.weekly]"
                        :nb-minute="rangeMinute[WORKTYPE.weekly]"
                        :is-editable="() => isEditable()"
                        :field-name="'weeklyFiveDaysEffNumHours'"
                        :work-type="WORKTYPE.weekly"
                        @change="handleChangeHourMin"
                      />
                    </b-form-group>
                    <b-form-group v-if="contract.workSixDays === 2" v-uni-for="'minWeek'" :label="FormMSG(127, '6 days effective hours')">
                      <input-date-time-picker
                        :label="FormMSG(127, '6 days effective hours')"
                        :uiid="'fdeh'"
                        :type="'text'"
                        :placeholder="'hh:mm'"
                        :is-submitted="isSubmitted"
                        :item="contract.weeklySixDaysEffNumHoursStr"
                        :nb-hour="rangeHour[WORKTYPE.weekly]"
                        :nb-minute="rangeMinute[WORKTYPE.weekly]"
                        :is-editable="() => isEditable()"
                        :field-name="'weeklySixDaysEffNumHours'"
                        :work-type="WORKTYPE.weekly"
                        @change="handleChangeHourMin"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col v-if="contract.workSixDays > 0" sm="12" md="12" lg="4" xl="4">
                    <b-form-group v-if="contract.workSixDays === 1" v-uni-for="'fdeq'" :label="FormMSG(64, '5 days equivalent hours')">
                      <input-date-time-picker
                        :label="FormMSG(64, '5 days equivalent hours')"
                        :uiid="'fdeq'"
                        :type="'text'"
                        :placeholder="'hh:mm'"
                        :is-submitted="isSubmitted"
                        :item="contract.weeklyFiveDaysEquNumHoursStr"
                        :nb-hour="rangeHour[WORKTYPE.weekly]"
                        :nb-minute="rangeMinute[WORKTYPE.weekly]"
                        :is-editable="() => isEditable()"
                        :field-name="'weeklyFiveDaysEquNumHours'"
                        :work-type="WORKTYPE.weekly"
                        @change="handleChangeHourMin"
                      />
                    </b-form-group>
                    <b-form-group v-if="contract.workSixDays === 2" v-uni-for="'fdeq'" :label="FormMSG(128, '6 days equivalent hours')">
                      <input-date-time-picker
                        :label="FormMSG(128, '6 days equivalent hours')"
                        :uiid="'fdeq'"
                        :type="'text'"
                        :placeholder="'hh:mm'"
                        :is-submitted="isSubmitted"
                        :item="contract.weeklySixDaysEquNumHoursStr"
                        :nb-hour="rangeHour[WORKTYPE.weekly]"
                        :nb-minute="rangeMinute[WORKTYPE.weekly]"
                        :is-editable="() => isEditable()"
                        :field-name="'weeklySixDaysEquNumHours'"
                        :work-type="WORKTYPE.weekly"
                        @change="handleChangeHourMin"
                      />
                    </b-form-group>
                  </b-col>
                </b-row>
              </div>
              <div v-else-if="showCCNAnnex3()">
                <b-row>
                  <b-col sm="12" md="12" lg="6" xl="6">
                    <input-currency
                      v-model="contract.hourlyRateAnnexThree"
                      :disabled="isEditable() === false"
                      :label="`${$screen.width <= 576 ? FormMSG(68, 'Hourly rate') : FormMSG(309, 'Hourly rate')}`"
                      :model-name="'contract.hourlyRateAnnexThree'"
                      :min="0"
                      :min-fraction-digits="0"
                      :max-fraction-digits="numberOfDecimals"
                      :has-element-to-append="true"
                      :element-append-choice="ELEMENT_APPEND_CHOICE.CURRENCY"
                      :error="isSubmitted && $v.contract.hourlyRateAnnexThree.$error"
                      :error-label="FormMSG(150, 'Please, value must be greater than 0')"
                      @input-number:value="onHandledNumber"
                      @change="computeSMG($event)"
                    />
                  </b-col>
                  <b-col sm="12" md="12" lg="6" xl="6">
                    <input-currency
                      v-model="contract.travelDailyRate"
                      :disabled="isEditable() === false"
                      :label="`${FormMSG(12, 'Travel rate ')}`"
                      :model-name="'contract.travelDailyRate'"
                      :min="0"
                      :min-fraction-digits="0"
                      :max-fraction-digits="numberOfDecimals"
                      :has-element-to-append="true"
                      :element-append-choice="ELEMENT_APPEND_CHOICE.CURRENCY"
                      @input-number:value="onHandledNumber"
                    />
                  </b-col>
                </b-row>
                <b-row>
                  <b-col sm="12" md="12" lg="4" xl="4">
                    <input-currency
                      v-model="contract.weeklyBonusAmount"
                      :disabled="isEditable() === false"
                      :label="`${FormMSG(69, 'Weekly bonus')}`"
                      :model-name="'contract.weeklyBonusAmount'"
                      :min="0"
                      :min-fraction-digits="0"
                      :max-fraction-digits="numberOfDecimals"
                      :has-element-to-append="true"
                      :element-append-choice="ELEMENT_APPEND_CHOICE.CURRENCY"
                      @input-number:value="onHandledNumber"
                    />
                    <input-currency
                      v-if="contract.workSixDays === 1"
                      v-model="contract.weeklyBonusAmountFiveDays"
                      :disabled="isEditable() === false"
                      :label="FormMSG(72, 'Weekly bonus')"
                      :model-name="'contract.weeklyBonusAmountFiveDays'"
                      :min="0"
                      :min-fraction-digits="0"
                      :max-fraction-digits="numberOfDecimals"
                      :has-element-to-append="true"
                      :element-append-choice="ELEMENT_APPEND_CHOICE.CURRENCY"
                      @input-number:value="onHandledNumber"
                    />
                    <input-currency
                      v-if="contract.workSixDays === 2"
                      v-model="contract.weeklyBonusAmountSixDays"
                      :disabled="isEditable() === false"
                      :label="FormMSG(77, 'Weekly bonus')"
                      :model-name="'contract.weeklyBonusAmountSixDays'"
                      :min="0"
                      :min-fraction-digits="0"
                      :max-fraction-digits="numberOfDecimals"
                      :has-element-to-append="true"
                      :element-append-choice="ELEMENT_APPEND_CHOICE.CURRENCY"
                      @input-number:value="onHandledNumber"
                    />
                  </b-col>
                  <b-col sm="12" md="12" lg="4" xl="4">
                    <input-currency
                      v-if="contract.workSixDays === 0"
                      v-model="contract.weeklyBaseMinimumSalary"
                      disabled
                      :label="FormMSG(70, 'Min. salary')"
                      :model-name="'contract.weeklyBaseMinimumSalary'"
                      :min="0"
                      :min-fraction-digits="0"
                      :max-fraction-digits="numberOfDecimals"
                      :has-element-to-append="true"
                      :element-append-choice="ELEMENT_APPEND_CHOICE.CURRENCY"
                      @input-number:value="onHandledNumber"
                    />
                    <input-currency
                      v-if="contract.workSixDays === 1"
                      v-model="contract.weeklyFiveDaysMinimumSalaryAnThree"
                      disabled
                      :label="FormMSG(73, '5 days min. salary')"
                      :model-name="'contract.weeklyFiveDaysMinimumSalaryAnThree'"
                      :min="0"
                      :min-fraction-digits="0"
                      :max-fraction-digits="numberOfDecimals"
                      :has-element-to-append="true"
                      :element-append-choice="ELEMENT_APPEND_CHOICE.CURRENCY"
                      @input-number:value="onHandledNumber"
                    />
                    <input-currency
                      v-if="contract.workSixDays === 2"
                      v-model="contract.weeklySixDaysMinimumSalaryAnThree"
                      disabled
                      :label="FormMSG(78, '6 days min. salary')"
                      :model-name="'contract.weeklySixDaysMinimumSalaryAnThree'"
                      :min="0"
                      :min-fraction-digits="0"
                      :max-fraction-digits="numberOfDecimals"
                      :has-element-to-append="true"
                      :element-append-choice="ELEMENT_APPEND_CHOICE.CURRENCY"
                      @input-number:value="onHandledNumber"
                    />
                  </b-col>
                  <b-col sm="12" md="12" lg="4" xl="4">
                    <input-currency
                      v-if="contract.workSixDays === 0"
                      v-model="contract.weeklyBaseRefSalary"
                      disabled
                      :label="FormMSG(71, 'Ref. salary')"
                      :model-name="'contract.weeklyBaseRefSalary'"
                      :min="0"
                      :min-fraction-digits="0"
                      :max-fraction-digits="numberOfDecimals"
                      :has-element-to-append="true"
                      :element-append-choice="ELEMENT_APPEND_CHOICE.CURRENCY"
                      @input-number:value="onHandledNumber"
                    />
                    <input-currency
                      v-if="contract.workSixDays === 1"
                      v-model="contract.weeklyFiveDaysRefSalary"
                      disabled
                      :label="FormMSG(76, '5 days ref. salary')"
                      :model-name="'contract.weeklyFiveDaysRefSalary'"
                      :min="0"
                      :min-fraction-digits="0"
                      :max-fraction-digits="numberOfDecimals"
                      :has-element-to-append="true"
                      :element-append-choice="ELEMENT_APPEND_CHOICE.CURRENCY"
                      @input-number:value="onHandledNumber"
                    />
                    <input-currency
                      v-if="contract.workSixDays === 2"
                      v-model="contract.weeklySixDaysRefSalary"
                      disabled
                      :label="FormMSG(81, '6 days ref. salary')"
                      :model-name="'contract.weeklySixDaysRefSalary'"
                      :min="0"
                      :min-fraction-digits="0"
                      :max-fraction-digits="numberOfDecimals"
                      :has-element-to-append="true"
                      :element-append-choice="ELEMENT_APPEND_CHOICE.CURRENCY"
                      @input-number:value="onHandledNumber"
                    />
                  </b-col>
                </b-row>
                <b-row>
                  <b-col sm="12" md="12" :lg="`${contract.workSixDays === 0 ? 6 : 4}`" :xl="`${contract.workSixDays === 0 ? 6 : 4}`">
                    <b-form-group v-uni-for="'minDay'" :label="`${$screen.width <= 576 ? FormMSG(24, 'Daily Work') : FormMSG(104, 'Daily hours')}`">
                      <input-date-time-picker
                        :label="`${$screen.width <= 576 ? FormMSG(24, 'Daily Work') : FormMSG(104, 'Daily hours')}`"
                        :uiid="'minDay'"
                        :type="'text'"
                        :placeholder="'hh:mm'"
                        :is-submitted="isSubmitted"
                        :item="contract.totMinPerDayStr"
                        :nb-hour="rangeHour[WORKTYPE.daily]"
                        :nb-minute="rangeMinute[WORKTYPE.daily]"
                        :is-editable="() => isEditable()"
                        :field-name="'totMinPerDay'"
                        :work-type="WORKTYPE.daily"
                        @change="handleChangeHourMin"
                      />
                      <!-- <div
												v-if="isSubmitted && !$v.contract.totMinPerDayStr.hourMinuteValid && contract.calculateSalary"
												class="invalid-feedback"
											>
												{{ FormMSG(151, 'Please, enter hours and minutes valid. (e.g: 45:00)') }}
											</div> -->
                    </b-form-group>
                  </b-col>
                  <b-col
                    v-if="contract.workSixDays === 0"
                    sm="12"
                    md="12"
                    :lg="`${contract.workSixDays === 0 ? 6 : 4}`"
                    :xl="`${contract.workSixDays === 0 ? 6 : 4}`"
                  >
                    <b-form-group v-uni-for="'minWeek'" :label="`${$screen.width <= 576 ? FormMSG(25, 'Weekly Work') : FormMSG(91, 'Weekly hours')}`">
                      <input-date-time-picker
                        :label="`${$screen.width <= 576 ? FormMSG(25, 'Weekly Work') : FormMSG(91, 'Weekly hours')}`"
                        :uiid="'minWeek'"
                        :type="'text'"
                        :placeholder="'hh:mm'"
                        :is-submitted="isSubmitted"
                        :item="contract.totMinPerWeekStr"
                        :nb-hour="rangeHour[WORKTYPE.weekly]"
                        :nb-minute="rangeMinute[WORKTYPE.weekly]"
                        :is-editable="() => isEditable()"
                        :field-name="'totMinPerWeek'"
                        :work-type="WORKTYPE.weekly"
                        @change="handleChangeHourMin"
                      />
                      <!-- <div
												v-if="isSubmitted && !$v.contract.totMinPerWeekStr.hourMinuteValid"
												class="invalid-feedback"
											>
												{{ FormMSG(151, 'Please, enter hours and minutes valid. (e.g: 45:00)') }}
											</div> -->
                    </b-form-group>
                  </b-col>
                  <b-col v-if="contract.workSixDays === 1" sm="12" md="12" lg="4" xl="4">
                    <b-form-group v-uni-for="'fdeh'" :label="FormMSG(74, '5 days effective hours')">
                      <input-date-time-picker
                        :label="FormMSG(74, '5 days effective hours')"
                        :uiid="'fdeh'"
                        :type="'text'"
                        :placeholder="'hh:mm'"
                        :is-submitted="isSubmitted"
                        :item="contract.weeklyFiveDaysEffNumHoursStr"
                        :nb-hour="rangeHour[WORKTYPE.weekly]"
                        :nb-minute="rangeMinute[WORKTYPE.weekly]"
                        :is-editable="() => isEditable()"
                        :field-name="'weeklyFiveDaysEffNumHours'"
                        :work-type="WORKTYPE.weekly"
                        @change="handleChangeHourMin"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col v-if="contract.workSixDays === 2" sm="12" md="12" lg="4" xl="4">
                    <b-form-group v-uni-for="'fdeh'" :label="FormMSG(79, '6 days effective hours')">
                      <input-date-time-picker
                        :label="FormMSG(79, '6 days effective hours')"
                        :uiid="'fdeh'"
                        :type="'text'"
                        :placeholder="'hh:mm'"
                        :is-submitted="isSubmitted"
                        :item="contract.weeklySixDaysEffNumHoursStr"
                        :nb-hour="rangeHour[WORKTYPE.weekly]"
                        :nb-minute="rangeMinute[WORKTYPE.weekly]"
                        :is-editable="() => isEditable()"
                        :field-name="'weeklySixDaysEffNumHours'"
                        :work-type="WORKTYPE.weekly"
                        @change="handleChangeHourMin"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col v-if="contract.workSixDays === 1" sm="12" md="12" lg="4" xl="4">
                    <b-form-group v-uni-for="'fdeq'" :label="FormMSG(75, '5 days equivalent hours')">
                      <input-date-time-picker
                        :label="FormMSG(75, '5 days equivalent hours')"
                        :uiid="'fdeq'"
                        :type="'text'"
                        :placeholder="'hh:mm'"
                        :is-submitted="isSubmitted"
                        :item="contract.weeklyFiveDaysEquNumHoursStr"
                        :nb-hour="rangeHour[WORKTYPE.weekly]"
                        :nb-minute="rangeMinute[WORKTYPE.weekly]"
                        :is-editable="() => isEditable()"
                        :field-name="'weeklyFiveDaysEquNumHours'"
                        :work-type="WORKTYPE.weekly"
                        @change="handleChangeHourMin"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col v-if="contract.workSixDays === 2" sm="12" md="12" lg="4" xl="4">
                    <b-form-group v-uni-for="'fdeq'" :label="FormMSG(80, '6 days equivalent hours')">
                      <input-date-time-picker
                        :label="FormMSG(80, '6 days equivalent hours')"
                        :uiid="'fdeq'"
                        :type="'text'"
                        :placeholder="'hh:mm'"
                        :is-submitted="isSubmitted"
                        :item="contract.weeklySixDaysEquNumHoursStr"
                        :nb-hour="rangeHour[WORKTYPE.weekly]"
                        :nb-minute="rangeMinute[WORKTYPE.weekly]"
                        :is-editable="() => isEditable()"
                        :field-name="'weeklySixDaysEquNumHours'"
                        :work-type="WORKTYPE.weekly"
                        @change="handleChangeHourMin"
                      />
                    </b-form-group>
                  </b-col>
                </b-row>
              </div>
              <div v-else-if="showCCN2642CDICDD()">
                <b-row>
                  <b-col
                    :sm="`${$screen.width <= 576 ? 0 : 12}`"
                    :md="`${$screen.width <= 576 ? 0 : 12}`"
                    :lg="`${$screen.width <= 576 ? 0 : 4}`"
                    :xl="`${$screen.width <= 576 ? 0 : 4}`"
                    :cols="`${$screen.width <= 576 ? 6 : 0}`"
                  >
                    <input-currency
                      v-model="contract.hourlyRate"
                      :disabled="isEditable() === false"
                      :label="`${$screen.width <= 576 ? FormMSG(89, 'Hourly rate') : FormMSG(13, 'Hourly rate')}`"
                      :model-name="'contract.hourlyRate'"
                      :min="0"
                      :min-fraction-digits="0"
                      :max-fraction-digits="numberOfDecimals"
                      :has-element-to-append="true"
                      :element-append-choice="ELEMENT_APPEND_CHOICE.CURRENCY"
                      @input-number:value="onHandledNumber"
                      @change="computeSMG($event)"
                    />
                  </b-col>
                  <b-col
                    :sm="`${$screen.width <= 576 ? 0 : 12}`"
                    :md="`${$screen.width <= 576 ? 0 : 12}`"
                    :lg="`${$screen.width <= 576 ? 0 : 4}`"
                    :xl="`${$screen.width <= 576 ? 0 : 4}`"
                    :cols="`${$screen.width <= 576 ? 6 : 0}`"
                  >
                    <input-currency
                      v-model="contract.dailyRate"
                      disabled
                      :label="`${$screen.width <= 576 ? FormMSG(11, 'Daily Rate') : FormMSG(90, 'Daily rate')}`"
                      :model-name="'contract.dailyRate'"
                      :min="0"
                      :min-fraction-digits="0"
                      :max-fraction-digits="numberOfDecimals"
                      :has-element-to-append="true"
                      :element-append-choice="ELEMENT_APPEND_CHOICE.CURRENCY"
                      @input-number:value="onHandledNumber"
                    />
                  </b-col>
                  <b-col
                    :sm="`${$screen.width <= 576 ? 0 : 12}`"
                    :md="`${$screen.width <= 576 ? 0 : 12}`"
                    :lg="`${$screen.width <= 576 ? 0 : 4}`"
                    :xl="`${$screen.width <= 576 ? 0 : 4}`"
                    :cols="`${$screen.width <= 576 ? 6 : 0}`"
                  >
                    <input-currency
                      v-model="contract.monthlyRate"
                      disabled
                      :label="`${$screen.width <= 576 ? FormMSG(311, 'Monthly rate') : FormMSG(303, 'Monthly rate')}`"
                      :model-name="'contract.monthlyRate'"
                      :min="0"
                      :min-fraction-digits="0"
                      :max-fraction-digits="numberOfDecimals"
                      :has-element-to-append="true"
                      :element-append-choice="ELEMENT_APPEND_CHOICE.CURRENCY"
                      @input-number:value="onHandledNumber"
                    />
                  </b-col>
                </b-row>
                <b-row>
                  <b-col
                    :sm="`${$screen.width <= 576 ? 0 : 12}`"
                    :md="`${$screen.width <= 576 ? 0 : 12}`"
                    :lg="`${$screen.width <= 576 ? 0 : 6}`"
                    :xl="`${$screen.width <= 576 ? 0 : 6}`"
                    :cols="`${$screen.width <= 576 ? 6 : 0}`"
                  >
                    <b-form-group v-uni-for="'minDay'" :label="`${$screen.width <= 576 ? FormMSG(24, 'Daily Work') : FormMSG(92, 'Daily hours')}`">
                      <input-date-time-picker
                        disabled
                        :label="`${$screen.width <= 576 ? FormMSG(24, 'Daily Work') : FormMSG(92, 'Daily hours')}`"
                        :uiid="'minDay'"
                        :type="'text'"
                        :placeholder="'hh:mm'"
                        :is-submitted="isSubmitted"
                        :item="contract.totMinPerDayStr"
                        :nb-hour="rangeHour[WORKTYPE.daily]"
                        :nb-minute="rangeMinute[WORKTYPE.daily]"
                        :is-editable="
                          () => {
                            return false;
                          }
                        "
                        :field-name="'totMinPerDay'"
                        :work-type="WORKTYPE.daily"
                        @change="handleChangeHourMin"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col
                    :sm="`${$screen.width <= 576 ? 0 : 12}`"
                    :md="`${$screen.width <= 576 ? 0 : 12}`"
                    :lg="`${$screen.width <= 576 ? 0 : 6}`"
                    :xl="`${$screen.width <= 576 ? 0 : 6}`"
                    :cols="`${$screen.width <= 576 ? 6 : 0}`"
                  >
                    <b-form-group v-uni-for="'minWeek'" :label="`${$screen.width <= 576 ? FormMSG(25, 'Weekly Work') : FormMSG(91, 'Weekly hours')}`">
                      <input-date-time-picker
                        :label="`${$screen.width <= 576 ? FormMSG(25, 'Weekly Work') : FormMSG(91, 'Weekly hours')}`"
                        :uiid="'minWeek'"
                        :type="'text'"
                        :placeholder="'hh:mm'"
                        :is-submitted="isSubmitted"
                        :item="contract.totMinPerWeekStr"
                        :nb-hour="rangeHour[WORKTYPE.weekly]"
                        :nb-minute="rangeMinute[WORKTYPE.weekly]"
                        :is-editable="
                          () => {
                            return false;
                          }
                        "
                        :field-name="'totMinPerWeek'"
                        :work-type="WORKTYPE.weekly"
                        @change="handleChangeHourMin"
                      />
                    </b-form-group>
                  </b-col>
                </b-row>
              </div>
              <div v-else-if="showCCN2642CDDU()">
                <div v-if="showCNN2624DailyBase()">
                  <b-row>
                    <b-col
                      :sm="`${$screen.width <= 576 ? 0 : 12}`"
                      :md="`${$screen.width <= 576 ? 0 : 12}`"
                      :lg="`${$screen.width <= 576 ? 0 : 4}`"
                      :xl="`${$screen.width <= 576 ? 0 : 4}`"
                      :cols="`${$screen.width <= 576 ? 6 : 0}`"
                    >
                      <input-currency
                        v-model="contract.hourlyRate"
                        :disabled="isEditable() === false"
                        :label="`${$screen.width <= 576 ? FormMSG(89, 'Hourly rate') : FormMSG(13, 'Hourly rate')}`"
                        :model-name="'contract.hourlyRate'"
                        :min="0"
                        :min-fraction-digits="0"
                        :max-fraction-digits="numberOfDecimals"
                        :has-element-to-append="true"
                        :element-append-choice="ELEMENT_APPEND_CHOICE.CURRENCY"
                        @input-number:value="onHandledNumber"
                        @change="computeSMG($event)"
                      />
                    </b-col>
                    <b-col
                      :sm="`${$screen.width <= 576 ? 0 : 12}`"
                      :md="`${$screen.width <= 576 ? 0 : 12}`"
                      :lg="`${$screen.width <= 576 ? 0 : 4}`"
                      :xl="`${$screen.width <= 576 ? 0 : 4}`"
                      :cols="`${$screen.width <= 576 ? 6 : 0}`"
                    >
                      <input-currency
                        v-model="contract.dailyRate"
                        disabled
                        :label="`${$screen.width <= 576 ? FormMSG(11, 'Daily Rate') : FormMSG(90, 'Daily rate')}`"
                        :model-name="'contract.dailyRate'"
                        :min="0"
                        :min-fraction-digits="0"
                        :max-fraction-digits="numberOfDecimals"
                        :has-element-to-append="true"
                        :element-append-choice="ELEMENT_APPEND_CHOICE.CURRENCY"
                        @input-number:value="onHandledNumber"
                      />
                    </b-col>
                    <b-col
                      :sm="`${$screen.width <= 576 ? 0 : 12}`"
                      :md="`${$screen.width <= 576 ? 0 : 12}`"
                      :lg="`${$screen.width <= 576 ? 0 : 4}`"
                      :xl="`${$screen.width <= 576 ? 0 : 4}`"
                      :cols="`${$screen.width <= 576 ? 6 : 0}`"
                    >
                      <b-form-group v-uni-for="'minDay'" :label="`${$screen.width <= 576 ? FormMSG(24, 'Daily Work') : FormMSG(92, 'Daily hours')}`">
                        <input-date-time-picker
                          :label="`${$screen.width <= 576 ? FormMSG(24, 'Daily Work') : FormMSG(92, 'Daily hours')}`"
                          :uiid="'minDay'"
                          :type="'text'"
                          :placeholder="'hh:mm'"
                          :is-submitted="isSubmitted"
                          :item="contract.totMinPerDayStr"
                          :nb-hour="rangeHour[WORKTYPE.daily]"
                          :nb-minute="rangeMinute[WORKTYPE.daily]"
                          :is-editable="
                            () => {
                              return false;
                            }
                          "
                          :field-name="'totMinPerDay'"
                          :work-type="WORKTYPE.daily"
                          @change="handleChangeHourMin"
                        />
                        <!-- <div
													v-if="isSubmitted && !$v.contract.totMinPerDayStr.hourMinuteValid && contract.calculateSalary"
													class="invalid-feedback"
												>
													{{ FormMSG(151, 'Please, enter hours and minutes valid. (e.g: 45:00)') }}
												</div> -->
                      </b-form-group>
                    </b-col>
                  </b-row>
                </div>
                <div v-if="showCNN2624WeeklyBase()">
                  <b-row>
                    <b-col
                      :sm="`${$screen.width <= 576 ? 0 : 12}`"
                      :md="`${$screen.width <= 576 ? 0 : 12}`"
                      :lg="`${$screen.width <= 576 ? 0 : 4}`"
                      :xl="`${$screen.width <= 576 ? 0 : 4}`"
                      :cols="`${$screen.width <= 576 ? 6 : 0}`"
                    >
                      <input-currency
                        v-model="contract.hourlyRate"
                        :disabled="isEditable() === false"
                        :label="`${$screen.width <= 576 ? FormMSG(89, 'Hourly rate') : FormMSG(13, 'Hourly rate')}`"
                        :model-name="'contract.hourlyRate'"
                        :min="0"
                        :min-fraction-digits="0"
                        :max-fraction-digits="numberOfDecimals"
                        :has-element-to-append="true"
                        :element-append-choice="ELEMENT_APPEND_CHOICE.CURRENCY"
                        @input-number:value="onHandledNumber"
                        @change="computeSMG($event)"
                      />
                    </b-col>
                    <b-col
                      :sm="`${$screen.width <= 576 ? 0 : 12}`"
                      :md="`${$screen.width <= 576 ? 0 : 12}`"
                      :lg="`${$screen.width <= 576 ? 0 : 4}`"
                      :xl="`${$screen.width <= 576 ? 0 : 4}`"
                      :cols="`${$screen.width <= 576 ? 6 : 0}`"
                    >
                      <input-currency
                        v-model="contract.dailyRate"
                        disabled
                        :label="`${$screen.width <= 576 ? FormMSG(11, 'Daily Rate') : FormMSG(90, 'Daily rate')}`"
                        :model-name="'contract.dailyRate'"
                        :min="0"
                        :min-fraction-digits="0"
                        :max-fraction-digits="numberOfDecimals"
                        :has-element-to-append="true"
                        :element-append-choice="ELEMENT_APPEND_CHOICE.CURRENCY"
                        @input-number:value="onHandledNumber"
                      />
                    </b-col>
                    <b-col
                      :sm="`${$screen.width <= 576 ? 0 : 12}`"
                      :md="`${$screen.width <= 576 ? 0 : 12}`"
                      :lg="`${$screen.width <= 576 ? 0 : 4}`"
                      :xl="`${$screen.width <= 576 ? 0 : 4}`"
                      :cols="`${$screen.width <= 576 ? 6 : 0}`"
                    >
                      <b-form-group v-uni-for="'minDay'" :label="`${$screen.width <= 576 ? FormMSG(24, 'Daily Work') : FormMSG(92, 'Daily hours')}`">
                        <input-date-time-picker
                          :label="`${$screen.width <= 576 ? FormMSG(24, 'Daily Work') : FormMSG(92, 'Daily hours')}`"
                          :uiid="'minDay'"
                          :type="'text'"
                          :placeholder="'hh:mm'"
                          :is-submitted="isSubmitted"
                          :item="contract.totMinPerDayStr"
                          :nb-hour="rangeHour[WORKTYPE.daily]"
                          :nb-minute="rangeMinute[WORKTYPE.daily]"
                          :is-editable="
                            () => {
                              return false;
                            }
                          "
                          :field-name="'totMinPerDay'"
                          :work-type="WORKTYPE.daily"
                          @change="handleChangeHourMin"
                        />
                        <!-- <div
													v-if="isSubmitted && !$v.contract.totMinPerDayStr.hourMinuteValid && contract.calculateSalary"
													class="invalid-feedback"
												>
													{{ FormMSG(151, 'Please, enter hours and minutes valid. (e.g: 45:00)') }}
												</div> -->
                      </b-form-group>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col
                      :sm="`${$screen.width <= 576 ? 0 : 12}`"
                      :md="`${$screen.width <= 576 ? 0 : 12}`"
                      :lg="`${$screen.width <= 576 ? 0 : 6}`"
                      :xl="`${$screen.width <= 576 ? 0 : 6}`"
                      :cols="`${$screen.width <= 576 ? 6 : 0}`"
                    >
                      <input-currency
                        v-model="contract.weeklyFiveDaysMinimumSalary"
                        disabled
                        :label="`${$screen.width <= 576 ? FormMSG(326, 'Tarif semaine (info)') : FormMSG(325, 'Tarif semaine (info)')}`"
                        :model-name="'contract.weeklyFiveDaysMinimumSalary'"
                        :min="0"
                        :min-fraction-digits="0"
                        :max-fraction-digits="numberOfDecimals"
                        :has-element-to-append="true"
                        :element-append-choice="ELEMENT_APPEND_CHOICE.CURRENCY"
                        @input-number:value="onHandledNumber"
                      />
                    </b-col>
                    <b-col
                      :sm="`${$screen.width <= 576 ? 0 : 12}`"
                      :md="`${$screen.width <= 576 ? 0 : 12}`"
                      :lg="`${$screen.width <= 576 ? 0 : 6}`"
                      :xl="`${$screen.width <= 576 ? 0 : 6}`"
                      :cols="`${$screen.width <= 576 ? 6 : 0}`"
                    >
                      <b-form-group v-uni-for="'minWeek'" :label="`${$screen.width <= 576 ? FormMSG(25, 'Weekly Work') : FormMSG(91, 'Weekly hours')}`">
                        <input-date-time-picker
                          :label="`${$screen.width <= 576 ? FormMSG(25, 'Weekly Work') : FormMSG(91, 'Weekly hours')}`"
                          :uiid="'minWeek'"
                          :type="'text'"
                          :placeholder="'hh:mm'"
                          :is-submitted="isSubmitted"
                          :item="contract.totMinPerWeekStr"
                          :nb-hour="rangeHour[WORKTYPE.weekly]"
                          :nb-minute="rangeMinute[WORKTYPE.weekly]"
                          :is-editable="
                            () => {
                              return false;
                            }
                          "
                          :field-name="'totMinPerWeek'"
                          :work-type="WORKTYPE.weekly"
                          @change="handleChangeHourMin"
                        />
                      </b-form-group>
                    </b-col>
                  </b-row>
                </div>
                <div v-if="showCNN2624MonthlyBase()">
                  <b-row>
                    <b-col
                      :sm="`${$screen.width <= 576 ? 0 : 12}`"
                      :md="`${$screen.width <= 576 ? 0 : 12}`"
                      :lg="`${$screen.width <= 576 ? 0 : 4}`"
                      :xl="`${$screen.width <= 576 ? 0 : 4}`"
                      :cols="`${$screen.width <= 576 ? 6 : 0}`"
                    >
                      <input-currency
                        v-model="contract.hourlyRate"
                        :disabled="isEditable() === false"
                        :label="`${$screen.width <= 576 ? FormMSG(89, 'Hourly rate') : FormMSG(13, 'Hourly rate')}`"
                        :model-name="'contract.hourlyRate'"
                        :min="0"
                        :min-fraction-digits="0"
                        :max-fraction-digits="numberOfDecimals"
                        :has-element-to-append="true"
                        :element-append-choice="ELEMENT_APPEND_CHOICE.CURRENCY"
                        @input-number:value="onHandledNumber"
                        @change="computeSMG($event)"
                      />
                    </b-col>
                    <b-col
                      :sm="`${$screen.width <= 576 ? 0 : 12}`"
                      :md="`${$screen.width <= 576 ? 0 : 12}`"
                      :lg="`${$screen.width <= 576 ? 0 : 4}`"
                      :xl="`${$screen.width <= 576 ? 0 : 4}`"
                      :cols="`${$screen.width <= 576 ? 6 : 0}`"
                    >
                      <input-currency
                        v-model="contract.dailyRate"
                        disabled
                        :label="`${$screen.width <= 576 ? FormMSG(11, 'Daily Rate') : FormMSG(90, 'Daily rate')}`"
                        :model-name="'contract.dailyRate'"
                        :min="0"
                        :min-fraction-digits="0"
                        :max-fraction-digits="numberOfDecimals"
                        :has-element-to-append="true"
                        :element-append-choice="ELEMENT_APPEND_CHOICE.CURRENCY"
                        @input-number:value="onHandledNumber"
                      />
                    </b-col>
                    <b-col
                      :sm="`${$screen.width <= 576 ? 0 : 12}`"
                      :md="`${$screen.width <= 576 ? 0 : 12}`"
                      :lg="`${$screen.width <= 576 ? 0 : 4}`"
                      :xl="`${$screen.width <= 576 ? 0 : 4}`"
                      :cols="`${$screen.width <= 576 ? 6 : 0}`"
                    >
                      <b-form-group v-uni-for="'minDay'" :label="`${$screen.width <= 576 ? FormMSG(24, 'Daily Work') : FormMSG(92, 'Daily hours')}`">
                        <input-date-time-picker
                          :label="`${$screen.width <= 576 ? FormMSG(24, 'Daily Work') : FormMSG(92, 'Daily hours')}`"
                          :uiid="'minDay'"
                          :type="'text'"
                          :placeholder="'hh:mm'"
                          :is-submitted="isSubmitted"
                          :item="contract.totMinPerDayStr"
                          :nb-hour="rangeHour[WORKTYPE.daily]"
                          :nb-minute="rangeMinute[WORKTYPE.daily]"
                          :is-editable="
                            () => {
                              return false;
                            }
                          "
                          :field-name="'totMinPerDay'"
                          :work-type="WORKTYPE.daily"
                          @change="handleChangeHourMin"
                        />
                        <!-- <div
													v-if="isSubmitted && !$v.contract.totMinPerDayStr.hourMinuteValid && contract.calculateSalary"
													class="invalid-feedback"
												>
													{{ FormMSG(151, 'Please, enter hours and minutes valid. (e.g: 45:00)') }}
												</div> -->
                      </b-form-group>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col
                      :sm="`${$screen.width <= 576 ? 0 : 12}`"
                      :md="`${$screen.width <= 576 ? 0 : 12}`"
                      :lg="`${$screen.width <= 576 ? 0 : 4}`"
                      :xl="`${$screen.width <= 576 ? 0 : 4}`"
                      :cols="`${$screen.width <= 576 ? 6 : 0}`"
                    >
                      <input-currency
                        v-model="contract.weeklyFiveDaysMinimumSalary"
                        disabled
                        :label="`${$screen.width <= 576 ? FormMSG(326, 'Tarif semaine (info)') : FormMSG(325, 'Tarif semaine (info)')}`"
                        :model-name="'contract.weeklyFiveDaysMinimumSalary'"
                        :min="0"
                        :min-fraction-digits="0"
                        :max-fraction-digits="numberOfDecimals"
                        :has-element-to-append="true"
                        :element-append-choice="ELEMENT_APPEND_CHOICE.CURRENCY"
                        @input-number:value="onHandledNumber"
                      />
                    </b-col>
                    <b-col
                      :sm="`${$screen.width <= 576 ? 0 : 12}`"
                      :md="`${$screen.width <= 576 ? 0 : 12}`"
                      :lg="`${$screen.width <= 576 ? 0 : 4}`"
                      :xl="`${$screen.width <= 576 ? 0 : 4}`"
                      :cols="`${$screen.width <= 576 ? 6 : 0}`"
                    >
                      <b-form-group v-uni-for="'minWeek'" :label="`${$screen.width <= 576 ? FormMSG(25, 'Weekly Work') : FormMSG(91, 'Weekly hours')}`">
                        <input-date-time-picker
                          :label="`${$screen.width <= 576 ? FormMSG(25, 'Weekly Work') : FormMSG(91, 'Weekly hours')}`"
                          :uiid="'minWeek'"
                          :type="'text'"
                          :placeholder="'hh:mm'"
                          :is-submitted="isSubmitted"
                          :item="contract.totMinPerWeekStr"
                          :nb-hour="rangeHour[WORKTYPE.weekly]"
                          :nb-minute="rangeMinute[WORKTYPE.weekly]"
                          :is-editable="
                            () => {
                              return false;
                            }
                          "
                          :field-name="'totMinPerWeek'"
                          :work-type="WORKTYPE.weekly"
                          @change="handleChangeHourMin"
                        />
                      </b-form-group>
                    </b-col>
                    <b-col
                      :sm="`${$screen.width <= 576 ? 0 : 12}`"
                      :md="`${$screen.width <= 576 ? 0 : 12}`"
                      :lg="`${$screen.width <= 576 ? 0 : 4}`"
                      :xl="`${$screen.width <= 576 ? 0 : 4}`"
                      :cols="`${$screen.width <= 576 ? 6 : 0}`"
                    >
                      <input-currency
                        v-model="contract.monthlyRate"
                        disabled
                        :label="`${$screen.width <= 576 ? FormMSG(311, 'Monthly rate') : FormMSG(303, 'Monthly rate')}`"
                        :model-name="'contract.monthlyRate'"
                        :min="0"
                        :min-fraction-digits="0"
                        :max-fraction-digits="numberOfDecimals"
                        :has-element-to-append="true"
                        :element-append-choice="ELEMENT_APPEND_CHOICE.CURRENCY"
                        @input-number:value="onHandledNumber"
                      />
                    </b-col>
                  </b-row>
                </div>
              </div>
            </div>
          </b-collapse>
          <!-- End Main details -->
          <!-- Begin Overtimes -->
          <div v-if="showOvt || showOvt1 || showOvt2 || showWeeklyOvt || showWeeklyOvt1 || showWeeklyOvt2" class="card-collapsible px-0 mt-4">
            <div
              class="header-card-collapsible inside d-flex flex-row align-items-center bgc-grey-light cursor-pointer"
              @click="handleClickHeader('overtimes')"
            >
              <div class="title w-90">
                <component :is="getLucideIcon(ICONS.ALARM_PLUS.name)" :color="ICONS.ALARM_PLUS.color" :size="22" />
                <div class="fz-1-35 ml-3">{{ FormMSG(131, 'Overtimes') }}</div>
              </div>
              <div class="cursor-pointer d-flex justify-content-end w-10">
                <component
                  :is="getLucideIcon(ICONS.CHEVRON_DOWN.name)"
                  v-if="!configAccordion['overtimes'].isVisible"
                  :color="ICONS.CHEVRON_DOWN.color"
                  :size="22"
                />
                <component
                  :is="getLucideIcon(ICONS.CHEVRON_UP.name)"
                  v-if="configAccordion['overtimes'].isVisible"
                  :color="ICONS.CHEVRON_UP.color"
                  :size="22"
                />
              </div>
            </div>
          </div>
          <b-collapse
            v-if="showOvt || showOvt1 || showOvt2 || showWeeklyOvt || showWeeklyOvt1 || showWeeklyOvt2"
            :visible="configAccordion['overtimes'].isVisible"
          >
            <div class="content-card-collapsible inside">
              <div v-if="showStandard()">
                <div v-if="showOvt || showOvt1 || showOvt2" class="label-layout pb-3">
                  <b-form-checkbox v-model="contract.dailyOvertime" size="lg" class="pj-cb-plus-2 cursor-pointer" :disabled="isEditable() === false">
                    {{ FormMSG(137, 'Daily overtimes') }}
                  </b-form-checkbox>
                </div>
                <div v-if="showOvt || showOvt1 || showOvt2">
                  <b-row v-if="contract.dailyOvertime">
                    <b-col
                      v-if="showOvt"
                      sm="12"
                      md="12"
                      :lg="`${showOvt1 && showOvt2 ? 4 : !showOvt1 && !showOvt2 ? 12 : 6}`"
                      :xl="`${showOvt1 && showOvt2 ? 4 : !showOvt1 && !showOvt2 ? 12 : 6}`"
                    >
                      <fieldset class="card-inside">
                        <legend class="card-inside">
                          {{ FormMSG(132, 'Daily overtime 1') }}
                        </legend>
                        <b-row align-h="around">
                          <b-col
                            sm="12"
                            md="12"
                            lg="5"
                            xl="5"
                            class="d-flex p-0 m-0"
                            :class="$screen.width > 576 ? 'flex-column justify-content-center' : 'flex-row'"
                            style="gap: 5px"
                          >
                            <b-form-group v-uni-for="'ovtLimit1'" :label="FormMSG(298, 'After')">
                              <input-date-time-picker
                                v-uni-for="'ovtLimit1'"
                                :label="FormMSG(298, 'After')"
                                :uiid="'ovtLimit1'"
                                :type="'text'"
                                :placeholder="'hh:mm'"
                                :is-submitted="isSubmitted"
                                :item="contract.ovtLimitStr"
                                :nb-hour="rangeHour[WORKTYPE.daily]"
                                :nb-minute="rangeMinute[WORKTYPE.daily]"
                                :is-editable="() => isEditable()"
                                :field-name="'ovtLimit'"
                                :work-type="WORKTYPE.daily"
                                @change="handleChangeHourMin"
                              />
                            </b-form-group>
                            <b-form-group
                              v-uni-for="'ovtLimitContinuousDay'"
                              :label="`${$screen.width <= 576 ? FormMSG(302, 'After (cont. day)') : FormMSG(299, 'After (continuous day)')}`"
                            >
                              <input-date-time-picker
                                :label="`${$screen.width <= 576 ? FormMSG(302, 'After (cont. day)') : FormMSG(299, 'After (continuous day)')}`"
                                :uiid="'ovtLimitContinuousDay'"
                                :type="'text'"
                                :placeholder="'hh:mm'"
                                :is-submitted="isSubmitted"
                                :item="contract.ovtLimitContinuousDayStr"
                                :nb-hour="rangeHour[WORKTYPE.daily]"
                                :nb-minute="rangeMinute[WORKTYPE.daily]"
                                :is-editable="() => isEditable()"
                                :field-name="'ovtLimitContinuousDay'"
                                :work-type="WORKTYPE.daily"
                                @change="handleChangeHourMin"
                              />
                            </b-form-group>
                          </b-col>
                          <b-col sm="12" md="12" lg="5" xl="5" class="d-flex flex-column justify-content-center p-0 m-0" style="gap: 5px">
                            <b-form-group v-uni-for="'overtimeRate1'" :label="FormMSG(95, 'Overtime rate')">
                              <b-input-group>
                                <b-form-input
                                  v-model="contract.overtimeRate"
                                  v-uni-id="'overtimeRate1'"
                                  :disabled="isEditable() === false"
                                  type="number"
                                  step="0.000001"
                                  min="0"
                                  placeholder="0"
                                />
                                <b-input-group-append>
                                  <b-input-group-text>
                                    <component :is="getLucideIcon(ICONS.PERCENT.name)" :color="ICONS.PERCENT.color" :size="16" />
                                  </b-input-group-text>
                                </b-input-group-append>
                              </b-input-group>
                            </b-form-group>
                            <b-form-group v-if="showDefaultPayCode">
                              <label v-if="$screen.width > 992" for="dayOvt1PayCode">&nbsp;</label>
                              <payroll-code
                                :ref="generateTextId('dayOvt1PayCode')"
                                style-type="select"
                                :value="contract.dayOvt1PayCode"
                                @payroll-code:input="setPayroolCodeValue($event, 'dayOvt1PayCode')"
                                @payroll-code:reset="resetPayroolCodeValue($event, 'dayOvt1PayCode')"
                              />
                            </b-form-group>
                          </b-col>
                        </b-row>
                      </fieldset>
                    </b-col>
                    <b-col
                      v-if="showOvt1"
                      sm="12"
                      md="12"
                      :lg="`${showOvt && showOvt2 ? 4 : !showOvt && !showOvt2 ? 12 : 6}`"
                      :xl="`${showOvt && showOvt2 ? 4 : !showOvt && !showOvt2 ? 12 : 6}`"
                    >
                      <fieldset class="card-inside">
                        <legend class="card-inside">
                          {{ FormMSG(133, 'Daily overtime 2') }}
                        </legend>
                        <b-row align-h="around">
                          <b-col
                            sm="12"
                            md="12"
                            lg="5"
                            xl="5"
                            class="d-flex p-0 m-0"
                            :class="$screen.width > 576 ? 'flex-column justify-content-center' : 'flex-row'"
                            style="gap: 5px"
                          >
                            <b-form-group v-uni-for="'ovtLimit2'" :label="FormMSG(298, 'After')">
                              <input-date-time-picker
                                :label="FormMSG(298, 'After')"
                                :uiid="'ovtLimit2'"
                                :type="'text'"
                                :placeholder="'hh:mm'"
                                :is-submitted="isSubmitted"
                                :item="contract.ovtLimit1Str"
                                :nb-hour="rangeHour[WORKTYPE.daily]"
                                :nb-minute="rangeMinute[WORKTYPE.daily]"
                                :is-editable="() => isEditable()"
                                :field-name="'ovtLimit1'"
                                :work-type="WORKTYPE.daily"
                                @change="handleChangeHourMin"
                              />
                            </b-form-group>
                            <b-form-group
                              v-uni-for="'ovtLimitContinuousDay1'"
                              :label="`${$screen.width <= 576 ? FormMSG(302, 'After (cont. day)') : FormMSG(299, 'After (continuous day)')}`"
                            >
                              <input-date-time-picker
                                :label="`${$screen.width <= 576 ? FormMSG(302, 'After (cont. day)') : FormMSG(299, 'After (continuous day)')}`"
                                :uiid="'ovtLimitContinuousDay1'"
                                :type="'text'"
                                :placeholder="'hh:mm'"
                                :is-submitted="isSubmitted"
                                :item="contract.ovtLimitContinuousDay1Str"
                                :nb-hour="rangeHour[WORKTYPE.daily]"
                                :nb-minute="rangeMinute[WORKTYPE.daily]"
                                :is-editable="() => isEditable()"
                                :field-name="'ovtLimitContinuousDay1'"
                                :work-type="WORKTYPE.daily"
                                @change="handleChangeHourMin"
                              />
                            </b-form-group>
                          </b-col>
                          <b-col sm="12" md="12" lg="5" xl="5" class="d-flex flex-column justify-content-center p-0 m-0" style="gap: 5px">
                            <b-form-group v-uni-for="'overtimeRate2'" :label="FormMSG(97, 'Overtime rate')">
                              <b-input-group>
                                <b-form-input
                                  v-model="contract.ovtRate1"
                                  v-uni-id="'overtimeRate2'"
                                  :disabled="isEditable() === false"
                                  type="number"
                                  step="0.000001"
                                  min="0"
                                  placeholder="0"
                                />
                                <b-input-group-append>
                                  <b-input-group-text>
                                    <component :is="getLucideIcon(ICONS.PERCENT.name)" :color="ICONS.PERCENT.color" :size="16" />
                                  </b-input-group-text>
                                </b-input-group-append>
                              </b-input-group>
                            </b-form-group>
                            <b-form-group v-if="showDefaultPayCode">
                              <label v-if="$screen.width > 992" for="dayOvt2PayCode">&nbsp;</label>
                              <payroll-code
                                :ref="generateTextId('dayOvt2PayCode')"
                                style-type="select"
                                :value="contract.dayOvt2PayCode"
                                @payroll-code:input="setPayroolCodeValue($event, 'dayOvt2PayCode')"
                                @payroll-code:reset="resetPayroolCodeValue($event, 'dayOvt2PayCode')"
                              />
                            </b-form-group>
                          </b-col>
                        </b-row>
                      </fieldset>
                    </b-col>
                    <b-col
                      v-if="showOvt2"
                      sm="12"
                      md="12"
                      :lg="`${showOvt1 && showOvt ? 4 : !showOvt1 && !showOvt ? 12 : 6}`"
                      :xl="`${showOvt1 && showOvt ? 4 : !showOvt1 && !showOvt ? 12 : 6}`"
                    >
                      <fieldset class="card-inside">
                        <legend class="card-inside">
                          {{ FormMSG(134, 'Daily overtime 3') }}
                        </legend>
                        <b-row align-h="around">
                          <b-col
                            sm="12"
                            md="12"
                            lg="5"
                            xl="5"
                            class="d-flex p-0 m-0"
                            :class="$screen.width > 576 ? 'flex-column justify-content-center' : 'flex-row'"
                            style="gap: 5px"
                          >
                            <b-form-group v-uni-for="'ovtLimit3'" :label="FormMSG(298, 'After')">
                              <input-date-time-picker
                                :label="FormMSG(298, 'After')"
                                :uiid="'ovtLimit3'"
                                :type="'text'"
                                :placeholder="'hh:mm'"
                                :is-submitted="isSubmitted"
                                :item="contract.ovtLimit2Str"
                                :nb-hour="rangeHour[WORKTYPE.daily]"
                                :nb-minute="rangeMinute[WORKTYPE.daily]"
                                :is-editable="() => isEditable()"
                                :field-name="'ovtLimit2'"
                                :work-type="WORKTYPE.daily"
                                @change="handleChangeHourMin"
                              />
                            </b-form-group>
                            <b-form-group
                              v-uni-for="'ovtLimitContinuousDay2'"
                              :label="`${$screen.width <= 576 ? FormMSG(302, 'After (cont. day)') : FormMSG(299, 'After (continuous day)')}`"
                            >
                              <input-date-time-picker
                                :label="`${$screen.width <= 576 ? FormMSG(302, 'After (cont. day)') : FormMSG(299, 'After (continuous day)')}`"
                                :uiid="'ovtLimitContinuousDay2'"
                                :type="'text'"
                                :placeholder="'hh:mm'"
                                :is-submitted="isSubmitted"
                                :item="contract.ovtLimitContinuousDay2Str"
                                :nb-hour="rangeHour[WORKTYPE.daily]"
                                :nb-minute="rangeMinute[WORKTYPE.daily]"
                                :is-editable="() => isEditable()"
                                :field-name="'ovtLimitContinuousDay2'"
                                :work-type="WORKTYPE.daily"
                                @change="handleChangeHourMin"
                              />
                            </b-form-group>
                          </b-col>
                          <b-col sm="12" md="12" lg="5" xl="5" class="d-flex flex-column justify-content-center p-0 m-0" style="gap: 5px">
                            <b-form-group v-uni-for="'overtimeRate3'" :label="FormMSG(136, 'Overtime rate')">
                              <b-input-group>
                                <b-form-input
                                  v-model="contract.ovtRate2"
                                  v-uni-id="'overtimeRate3'"
                                  :disabled="isEditable() === false"
                                  type="number"
                                  step="0.000001"
                                  min="0"
                                  placeholder="0"
                                />
                                <b-input-group-append>
                                  <b-input-group-text>
                                    <component :is="getLucideIcon(ICONS.PERCENT.name)" :color="ICONS.PERCENT.color" :size="16" />
                                  </b-input-group-text>
                                </b-input-group-append>
                              </b-input-group>
                            </b-form-group>
                            <b-form-group v-if="showDefaultPayCode">
                              <label v-if="$screen.width > 992" for="dayOvt3PayCode">&nbsp;</label>
                              <payroll-code
                                :ref="generateTextId('dayOvt3PayCode')"
                                style-type="select"
                                :value="contract.dayOvt3PayCode"
                                @payroll-code:input="setPayroolCodeValue($event, 'dayOvt3PayCode')"
                                @payroll-code:reset="resetPayroolCodeValue($event, 'dayOvt3PayCode')"
                              />
                            </b-form-group>
                          </b-col>
                        </b-row>
                      </fieldset>
                    </b-col>
                  </b-row>
                </div>
              </div>
              <div v-if="(showOvt || showOvt1 || showOvt2) && showStandard()" class="divider" />
              <div
                v-if="showWeeklyOvt || showWeeklyOvt1 || showWeeklyOvt2"
                class="label-layout pb-3"
                :class="`${(showOvt || showOvt1 || showOvt2) && (showWeeklyOvt || showWeeklyOvt1 || showWeeklyOvt2) && !showStandard() ? 'mt-4' : ''}`"
              >
                <b-form-checkbox v-model="contract.weeklyOvertime" size="lg" class="pj-cb-plus-2 cursor-pointer" :disabled="isEditable() === false">
                  {{ FormMSG(138, 'Weekly overtimes') }}
                </b-form-checkbox>
              </div>
              <div v-if="showWeeklyOvt || showWeeklyOvt1 || showWeeklyOvt2">
                <b-row v-if="contract.weeklyOvertime">
                  <b-col
                    v-if="showWeeklyOvt"
                    sm="12"
                    md="12"
                    :lg="`${showWeeklyOvt1 && showWeeklyOvt2 ? 4 : !showWeeklyOvt1 && !showWeeklyOvt2 ? 12 : 6}`"
                    :xl="`${showWeeklyOvt1 && showWeeklyOvt2 ? 4 : !showWeeklyOvt1 && !showWeeklyOvt2 ? 12 : 6}`"
                  >
                    <fieldset class="card-inside">
                      <legend class="card-inside">
                        {{ FormMSG(139, 'Weekly overtime 1') }}
                      </legend>
                      <b-row>
                        <b-col cols="6">
                          <b-form-group v-uni-for="'weeklyOvtLimit1'" :label="FormMSG(152, 'Overtime after')">
                            <input-date-time-picker
                              :label="FormMSG(152, 'Overtime after')"
                              :uiid="'weeklyOvtLimit1'"
                              :type="'text'"
                              :placeholder="'hh:mm'"
                              :is-submitted="isSubmitted"
                              :item="contract.weeklyOvtOneLimitStr"
                              :nb-hour="rangeHour[WORKTYPE.weekly]"
                              :nb-minute="rangeMinute[WORKTYPE.weekly]"
                              :is-editable="() => isEditable()"
                              :field-name="'weeklyOvtOneLimit'"
                              :work-type="WORKTYPE.weekly"
                              @change="handleChangeHourMin"
                            />
                          </b-form-group>
                        </b-col>
                        <b-col cols="6">
                          <b-form-group v-uni-for="'weeklyOvertimeRate1'" :label="FormMSG(153, 'Overtime rate')">
                            <b-input-group>
                              <b-form-input
                                v-model="contract.weeklyOvtOneRate"
                                v-uni-id="'weeklyOvertimeRate1'"
                                :disabled="isEditable() === false"
                                type="number"
                                step="0.000001"
                                min="0"
                                placeholder="0"
                                @change="computeSMG()"
                              />
                              <b-input-group-append>
                                <b-input-group-text>
                                  <component :is="getLucideIcon(ICONS.PERCENT.name)" :color="ICONS.PERCENT.color" :size="16" />
                                </b-input-group-text>
                              </b-input-group-append>
                            </b-input-group>
                          </b-form-group>
                        </b-col>
                      </b-row>
                      <b-row v-if="showDefaultPayCode">
                        <b-col cols="12">
                          <b-form-group>
                            <label v-if="$screen.width > 992" for="weekOvt1PayCode">&nbsp;</label>
                            <payroll-code
                              :ref="generateTextId('weekOvt1PayCode')"
                              style-type="select"
                              :value="contract.weekOvt1PayCode"
                              @payroll-code:input="setPayroolCodeValue($event, 'weekOvt1PayCode')"
                              @payroll-code:reset="resetPayroolCodeValue($event, 'weekOvt1PayCode')"
                            />
                          </b-form-group>
                        </b-col>
                      </b-row>
                    </fieldset>
                  </b-col>
                  <b-col
                    v-if="showWeeklyOvt1"
                    sm="12"
                    md="12"
                    :lg="`${showWeeklyOvt && showWeeklyOvt2 ? 4 : !showWeeklyOvt && !showWeeklyOvt2 ? 12 : 6}`"
                    :xl="`${showWeeklyOvt && showWeeklyOvt2 ? 4 : !showWeeklyOvt && !showWeeklyOvt2 ? 12 : 6}`"
                  >
                    <fieldset class="card-inside">
                      <legend class="card-inside">
                        {{ FormMSG(161, 'Weekly overtime 2') }}
                      </legend>
                      <b-row>
                        <b-col cols="6">
                          <b-form-group v-uni-for="'weeklyOvtLimit2'" :label="FormMSG(156, 'Overtime after')">
                            <input-date-time-picker
                              :label="FormMSG(156, 'Overtime after')"
                              :uiid="'weeklyOvtLimit2'"
                              :type="'text'"
                              :placeholder="'hh:mm'"
                              :is-submitted="isSubmitted"
                              :item="contract.weeklyOvtTwoLimitStr"
                              :nb-hour="rangeHour[WORKTYPE.weekly]"
                              :nb-minute="rangeMinute[WORKTYPE.weekly]"
                              :is-editable="() => isEditable()"
                              :field-name="'weeklyOvtTwoLimit'"
                              :work-type="WORKTYPE.weekly"
                              @change="handleChangeHourMin"
                            />
                          </b-form-group>
                        </b-col>
                        <b-col cols="6">
                          <b-form-group v-uni-for="'weeklyOvertimeRate2'" :label="FormMSG(157, 'Overtime rate')">
                            <b-input-group>
                              <b-form-input
                                v-model="contract.weeklyOvtTwoRate"
                                v-uni-id="'weeklyOvertimeRate2'"
                                :disabled="isEditable() === false"
                                type="number"
                                step="0.000001"
                                min="0"
                                placeholder="0"
                                @change="computeSMG()"
                              />
                              <b-input-group-append>
                                <b-input-group-text>
                                  <component :is="getLucideIcon(ICONS.PERCENT.name)" :color="ICONS.PERCENT.color" :size="16" />
                                </b-input-group-text>
                              </b-input-group-append>
                            </b-input-group>
                          </b-form-group>
                        </b-col>
                      </b-row>
                      <b-row v-if="showDefaultPayCode">
                        <b-col cols="12">
                          <b-form-group>
                            <label v-if="$screen.width > 992" for="weekOvt2PayCode">&nbsp;</label>
                            <payroll-code
                              :ref="generateTextId('weekOvt2PayCode')"
                              style-type="select"
                              :value="contract.weekOvt2PayCode"
                              @payroll-code:input="setPayroolCodeValue($event, 'weekOvt2PayCode')"
                              @payroll-code:reset="resetPayroolCodeValue($event, 'weekOvt2PayCode')"
                            />
                          </b-form-group>
                        </b-col>
                      </b-row>
                    </fieldset>
                  </b-col>
                  <b-col
                    v-if="showWeeklyOvt2"
                    sm="12"
                    md="12"
                    :lg="`${showWeeklyOvt1 && showWeeklyOvt ? 4 : !showWeeklyOvt1 && !showWeeklyOvt ? 12 : 6}`"
                    :xl="`${showWeeklyOvt1 && showWeeklyOvt ? 4 : !showWeeklyOvt1 && !showWeeklyOvt ? 12 : 6}`"
                  >
                    <fieldset class="card-inside">
                      <legend class="card-inside">
                        {{ FormMSG(158, 'Weekly overtime 3') }}
                      </legend>
                      <b-row>
                        <b-col cols="6">
                          <b-form-group v-uni-for="'weeklyOvtLimit3'" :label="FormMSG(159, 'Overtime after')">
                            <input-date-time-picker
                              :label="FormMSG(159, 'Overtime after')"
                              :uiid="'weeklyOvtLimit3'"
                              :type="'text'"
                              :placeholder="'hh:mm'"
                              :is-submitted="isSubmitted"
                              :item="contract.weeklyOvtThreeLimitStr"
                              :nb-hour="rangeHour[WORKTYPE.weekly]"
                              :nb-minute="rangeMinute[WORKTYPE.weekly]"
                              :is-editable="() => isEditable()"
                              :field-name="'weeklyOvtThreeLimit'"
                              :work-type="WORKTYPE.weekly"
                              @change="handleChangeHourMin"
                            />
                          </b-form-group>
                        </b-col>
                        <b-col cols="6">
                          <b-form-group v-uni-for="'weeklyOvertimeRate3'" :label="FormMSG(160, 'Overtime rate')">
                            <b-input-group>
                              <b-form-input
                                v-model="contract.weeklyOvtThreeRate"
                                v-uni-id="'weeklyOvertimeRate3'"
                                :disabled="isEditable() === false"
                                type="number"
                                step="0.000001"
                                min="0"
                                placeholder="0"
                                @change="computeSMG()"
                              />
                              <b-input-group-append>
                                <b-input-group-text>
                                  <component :is="getLucideIcon(ICONS.PERCENT.name)" :color="ICONS.PERCENT.color" :size="16" />
                                </b-input-group-text>
                              </b-input-group-append>
                            </b-input-group>
                          </b-form-group>
                        </b-col>
                      </b-row>
                      <b-row v-if="showDefaultPayCode">
                        <b-col cols="12">
                          <b-form-group>
                            <label v-if="$screen.width > 992" for="weekOvt3PayCode">&nbsp;</label>
                            <payroll-code
                              :ref="generateTextId('weekOvt3PayCode')"
                              style-type="select"
                              :value="contract.weekOvt3PayCode"
                              @payroll-code:input="setPayroolCodeValue($event, 'weekOvt3PayCode')"
                              @payroll-code:reset="resetPayroolCodeValue($event, 'weekOvt3PayCode')"
                            />
                          </b-form-group>
                        </b-col>
                      </b-row>
                    </fieldset>
                  </b-col>
                </b-row>
              </div>
            </div>
          </b-collapse>
          <!-- End Overtimes -->
          <!-- Begin Night Time -->
          <div v-if="showNightHours" class="card-collapsible px-0 mt-4">
            <div
              class="header-card-collapsible inside d-flex flex-row align-items-center bgc-grey-light cursor-pointer"
              @click="handleClickHeader('night-time')"
            >
              <div class="title w-90">
                <component :is="getLucideIcon(ICONS.MOON.name)" :color="ICONS.MOON.color" :size="22" />
                <div class="fz-1-35 ml-3">{{ FormMSG(162, 'Night Time') }}</div>
              </div>
              <div class="cursor-pointer d-flex justify-content-end w-10">
                <component
                  :is="getLucideIcon(ICONS.CHEVRON_DOWN.name)"
                  v-if="!configAccordion['night-time'].isVisible"
                  :color="ICONS.CHEVRON_DOWN.color"
                  :size="22"
                />
                <component
                  :is="getLucideIcon(ICONS.CHEVRON_UP.name)"
                  v-if="configAccordion['night-time'].isVisible"
                  :color="ICONS.CHEVRON_UP.color"
                  :size="22"
                />
              </div>
            </div>
          </div>
          <b-collapse v-if="showNightHours" :visible="configAccordion['night-time'].isVisible">
            <div class="content-card-collapsible inside">
              <b-row>
                <b-col
                  :sm="`${$screen.width <= 576 ? 0 : 6}`"
                  :md="`${$screen.width <= 576 ? 0 : 6}`"
                  :lg="`${$screen.width <= 576 ? 0 : 3}`"
                  :xl="`${$screen.width <= 576 ? 0 : 3}`"
                  :cols="`${$screen.width <= 576 ? 6 : 0}`"
                >
                  <b-form-group v-uni-for="'nightStart'" :label="FormMSG(163, 'Night time start')">
                    <b-form-input
                      v-uni-id="'nightStart'"
                      :disabled="isEditable() === false"
                      type="time"
                      :value="contract.nightTimeStart"
                      placeholder="hh:mm"
                      @blur="updateNightStart($event)"
                    />
                  </b-form-group>
                </b-col>
                <b-col
                  :sm="`${$screen.width <= 576 ? 0 : 6}`"
                  :md="`${$screen.width <= 576 ? 0 : 6}`"
                  :lg="`${$screen.width <= 576 ? 0 : 3}`"
                  :xl="`${$screen.width <= 576 ? 0 : 3}`"
                  :cols="`${$screen.width <= 576 ? 6 : 0}`"
                >
                  <b-form-group v-uni-for="'nightEnd'" :label="FormMSG(164, 'Night time end')">
                    <b-form-input
                      v-uni-id="'nightEnd'"
                      :disabled="isEditable() === false"
                      type="time"
                      :value="contract.nightTimeEnd"
                      placeholder="hh:mm"
                      @blur="updateNightEnd($event)"
                    />
                  </b-form-group>
                </b-col>
                <b-col
                  :sm="`${$screen.width <= 576 ? 0 : 12}`"
                  :md="`${$screen.width <= 576 ? 0 : 12}`"
                  :lg="`${$screen.width <= 576 ? 0 : 3}`"
                  :xl="`${$screen.width <= 576 ? 0 : 3}`"
                  :cols="`${$screen.width <= 576 ? 12 : 0}`"
                >
                  <b-form-group v-uni-for="'nightRate'" :label="FormMSG(165, 'Night hours rate')">
                    <b-input-group class="d-flex flex-column">
                      <div class="d-flex flex-row">
                        <b-form-input
                          v-model="contract.nightTimeRate"
                          v-uni-id="'nightRate'"
                          :disabled="isEditable() === false"
                          type="number"
                          step="0.000001"
                          min="0"
                          placeholder="0"
                          style="border-radius: 8px 0 0 8px"
                        />
                        <b-input-group-append>
                          <b-input-group-text>
                            <percent color="#06263E" :size="16" class="icon" />
                          </b-input-group-text>
                        </b-input-group-append>
                      </div>
                      <div v-if="showDefaultPayCode" class="info-message fix-info-message-per-diem ml-1">
                        <div><info :size="16" /></div>
                        <div class="label">
                          <span style="color: #00a09c">+</span>
                          {{ calculateAverageRate(contract.hourlyRate, contract.nightTimeRate) }} {{ currencySymbol }}
                          {{ FormMSG(191, 'per hour') }}
                        </div>
                      </div>
                    </b-input-group>
                  </b-form-group>
                </b-col>
                <b-col
                  v-if="showStandard()"
                  :sm="`${$screen.width <= 576 ? 0 : 12}`"
                  :md="`${$screen.width <= 576 ? 0 : 12}`"
                  :lg="`${$screen.width <= 576 ? 0 : 3}`"
                  :xl="`${$screen.width <= 576 ? 0 : 3}`"
                  :cols="`${$screen.width <= 576 ? 12 : 0}`"
                  :class="`${showDefaultPayCode ? '' : 'd-flex align-items-center'}`"
                >
                  <div v-if="!showDefaultPayCode" class="info-message fix-info-message-per-diem">
                    <div><info :size="16" /></div>
                    <div class="label">
                      <span style="color: #00a09c">+</span>
                      {{ calculateAverageRate(contract.hourlyRate, contract.nightTimeRate) }} {{ currencySymbol }}
                      {{ FormMSG(191, 'per hour') }}
                    </div>
                  </div>
                  <div v-else class="w-100" :style="`margin:${$screen.width <= 992 ? '0' : '6px 0 0 0'}`">
                    <b-form-group>
                      <label v-if="$screen.width > 992" for="nightTimePayCode">&nbsp;</label>
                      <payroll-code
                        :ref="generateTextId('nightTimePayCode')"
                        style-type="select"
                        :value="contract.nightTimePayCode"
                        @payroll-code:input="setPayroolCodeValue($event, 'nightTimePayCode')"
                        @payroll-code:reset="resetPayroolCodeValue($event, 'nightTimePayCode')"
                      />
                    </b-form-group>
                  </div>
                </b-col>
              </b-row>
            </div>
          </b-collapse>
          <!-- End Night Time -->
          <!-- Begin Rest Time -->
          <div v-if="showTooEarlyHours" class="card-collapsible px-0 mt-4">
            <div
              class="header-card-collapsible inside d-flex flex-row align-items-center bgc-grey-light cursor-pointer"
              @click="handleClickHeader('rest-time')"
            >
              <div class="title w-90">
                <component :is="getLucideIcon(ICONS.SUNMOON.name)" :color="ICONS.SUNMOON.color" :size="22" />
                <div class="fz-1-35 ml-3">{{ FormMSG(166, 'Rest Time') }}</div>
              </div>
              <div class="cursor-pointer d-flex justify-content-end w-10">
                <component
                  :is="getLucideIcon(ICONS.CHEVRON_DOWN.name)"
                  v-if="!configAccordion['rest-time'].isVisible"
                  :color="ICONS.CHEVRON_DOWN.color"
                  :size="22"
                />
                <component
                  :is="getLucideIcon(ICONS.CHEVRON_UP.name)"
                  v-if="configAccordion['rest-time'].isVisible"
                  :color="ICONS.CHEVRON_UP.color"
                  :size="22"
                />
              </div>
            </div>
          </div>
          <b-collapse v-if="showTooEarlyHours" :visible="configAccordion['rest-time'].isVisible">
            <div class="content-card-collapsible inside">
              <b-row>
                <b-col sm="6" md="6" lg="3" xl="3">
                  <b-form-group v-uni-for="'minTimeBetweenDays'" :label="FormMSG(22, 'Min time between days')">
                    <b-form-input
                      v-uni-id="'minTimeBetweenDays'"
                      :disabled="isEditable() === false"
                      type="time"
                      :value="contract.minTimeBetweenDays"
                      @blur="updateMinTimeBetweenDays($event)"
                    />
                  </b-form-group>
                </b-col>
                <b-col sm="6" md="6" lg="3" xl="3">
                  <b-form-group v-uni-for="'minBetW'" :label="FormMSG(149, 'Min time between weeks')">
                    <input-date-time-picker
                      :label="FormMSG(149, 'Min time between weeks')"
                      :uiid="'minBetW'"
                      :type="'text'"
                      :placeholder="'hh:mm'"
                      :is-submitted="isSubmitted"
                      :item="contract.minTimeBetweenWeekStr"
                      :nb-hour="rangeHour[WORKTYPE.weekly]"
                      :nb-minute="rangeMinute[WORKTYPE.weekly]"
                      :is-editable="() => isEditable()"
                      :field-name="'minTimeBetweenWeek'"
                      :work-type="WORKTYPE.weekly"
                      @change="handleChangeHourMin"
                    />
                  </b-form-group>
                </b-col>
                <b-col sm="6" md="6" lg="3" xl="3">
                  <b-form-group v-uni-for="'anticRate'" :label="FormMSG(16, 'Aniticipated hours rate')">
                    <b-input-group class="d-flex flex-column">
                      <div class="d-flex flex-row">
                        <b-form-input
                          v-model="contract.hourBeforeTimeRate"
                          v-uni-id="'anticRate'"
                          :disabled="isEditable() === false"
                          type="number"
                          step="0.000001"
                          min="0"
                          placeholder="0"
                          style="border-radius: 8px 0 0 8px"
                        />
                        <b-input-group-append>
                          <b-input-group-text>
                            <percent color="#06263E" :size="16" class="icon" />
                          </b-input-group-text>
                        </b-input-group-append>
                      </div>
                      <div v-if="showDefaultPayCode" class="info-message fix-info-message-per-diem ml-1">
                        <div><info :size="16" /></div>
                        <div class="label">
                          <span style="color: #00a09c">+</span>
                          {{ calculateAverageRate(contract.hourlyRate, contract.hourBeforeTimeRate) }} {{ currencySymbol }}
                          {{ FormMSG(191, 'per hour') }}
                        </div>
                      </div>
                    </b-input-group>
                  </b-form-group>
                </b-col>
                <b-col v-if="showStandard()" sm="6" md="6" lg="3" xl="3" :class="`${showDefaultPayCode ? '' : 'd-flex align-items-center'}`">
                  <div v-if="!showDefaultPayCode" class="info-message fix-info-message-per-diem">
                    <div><info :size="16" /></div>
                    <div class="label">
                      <span style="color: #00a09c">+</span>
                      {{ calculateAverageRate(contract.hourlyRate, contract.hourBeforeTimeRate) }} {{ currencySymbol }}
                      {{ FormMSG(191, 'per hour') }}
                    </div>
                  </div>
                  <div v-else class="w-100" :style="`margin:${$screen.width <= 576 ? '0' : '6px 0 0 0'}`">
                    <b-form-group>
                      <label v-if="$screen.width > 576" for="restPayCode">&nbsp;</label>
                      <payroll-code
                        :ref="generateTextId('restPayCode')"
                        style-type="select"
                        :value="contract.restPayCode"
                        @payroll-code:input="setPayroolCodeValue($event, 'restPayCode')"
                        @payroll-code:reset="resetPayroolCodeValue($event, 'restPayCode')"
                      />
                    </b-form-group>
                  </div>
                </b-col>
              </b-row>
            </div>
          </b-collapse>
          <!-- End Rest Time -->
          <!-- Begin Transport -->
          <div v-if="showTransport" class="card-collapsible px-0 mt-4">
            <div
              class="header-card-collapsible inside d-flex flex-row align-items-center bgc-grey-light cursor-pointer"
              @click="handleClickHeader('transport')"
            >
              <div class="title w-90">
                <component :is="getLucideIcon(ICONS.BUS.name)" :color="ICONS.BUS.color" :size="22" />
                <div class="fz-1-35 ml-3">{{ FormMSG(169, 'Transport') }}</div>
              </div>
              <div class="cursor-pointer d-flex justify-content-end w-10">
                <component
                  :is="getLucideIcon(ICONS.CHEVRON_DOWN.name)"
                  v-if="!configAccordion['transport'].isVisible"
                  :color="ICONS.CHEVRON_DOWN.color"
                  :size="22"
                />
                <component
                  :is="getLucideIcon(ICONS.CHEVRON_UP.name)"
                  v-if="configAccordion['transport'].isVisible"
                  :color="ICONS.CHEVRON_UP.color"
                  :size="22"
                />
              </div>
            </div>
          </div>
          <b-collapse v-if="showTransport" :visible="configAccordion['transport'].isVisible">
            <div class="content-card-collapsible inside">
              <b-row>
                <b-col sm="6" md="6" :lg="`${showDefaultPayCode ? 4 : 6}`" :xl="`${showDefaultPayCode ? 4 : 6}`">
                  <b-form-group v-uni-for="'transportPaid'" :label="FormMSG(146, 'Paid if above')">
                    <input-date-time-picker
                      :label="FormMSG(146, 'Paid if above')"
                      :uiid="'transportPaid'"
                      :type="'text'"
                      :placeholder="'hh:mm'"
                      :is-submitted="isSubmitted"
                      :item="contract.transportPaidAfterStr"
                      :nb-hour="rangeHour[WORKTYPE.daily]"
                      :nb-minute="rangeMinute[WORKTYPE.daily]"
                      :is-editable="() => isEditable()"
                      :field-name="'transportPaidAfter'"
                      :work-type="WORKTYPE.daily"
                      @change="handleChangeHourMin"
                    />
                  </b-form-group>
                </b-col>
                <b-col sm="6" md="6" :lg="`${showDefaultPayCode ? 4 : 6}`" :xl="`${showDefaultPayCode ? 4 : 6}`">
                  <input-currency
                    v-model="contract.transportRate"
                    v-uni-for="'transportRate'"
                    :disabled="isEditable() === false"
                    :label="FormMSG(147, 'Amount (/h)')"
                    :model-name="'contract.transportRate'"
                    :min="0"
                    :min-fraction-digits="0"
                    :max-fraction-digits="numberOfDecimals"
                    :has-element-to-append="true"
                    :element-append-choice="ELEMENT_APPEND_CHOICE.CURRENCY"
                    @input-number:value="onHandledNumber"
                  />
                </b-col>
                <b-col v-if="showDefaultPayCode" sm="12" md="12" lg="4" xl="4" :style="`margin:${$screen.width <= 992 ? '0' : '6px 0 0 0'}`">
                  <b-form-group v-if="showDefaultPayCode">
                    <label v-if="$screen.width > 992" for="transportPayCode">&nbsp;</label>
                    <payroll-code
                      :ref="generateTextId('transportPayCode')"
                      style-type="select"
                      :value="contract.transportPayCode"
                      @payroll-code:input="setPayroolCodeValue($event, 'transportPayCode')"
                      @payroll-code:reset="resetPayroolCodeValue($event, 'transportPayCode')"
                    />
                  </b-form-group>
                </b-col>
              </b-row>
            </div>
          </b-collapse>
          <!-- End Transport -->
          <!-- Begin Special days rates -->
          <div v-if="showSixthDayRate || showSeventhDayRate || showSundayRate" class="card-collapsible px-0 mt-4">
            <div
              class="header-card-collapsible inside d-flex flex-row align-items-center bgc-grey-light cursor-pointer"
              @click="handleClickHeader('special-days-rates')"
            >
              <div class="title w-90">
                <component :is="getLucideIcon(ICONS.STAR.name)" :color="ICONS.STAR.color" :size="22" />
                <div class="fz-1-35 ml-3">
                  {{ FormMSG(170, 'Special days rates') }}
                </div>
              </div>
              <div class="cursor-pointer d-flex justify-content-end w-10">
                <component
                  :is="getLucideIcon(ICONS.CHEVRON_DOWN.name)"
                  v-if="!configAccordion['special-days-rates'].isVisible"
                  :color="ICONS.CHEVRON_DOWN.color"
                  :size="22"
                />
                <component
                  :is="getLucideIcon(ICONS.CHEVRON_UP.name)"
                  v-if="configAccordion['special-days-rates'].isVisible"
                  :color="ICONS.CHEVRON_UP.color"
                  :size="22"
                />
              </div>
            </div>
          </div>
          <b-collapse v-if="showSixthDayRate || showSeventhDayRate || showSundayRate" :visible="configAccordion['special-days-rates'].isVisible">
            <div class="content-card-collapsible inside">
              <b-row>
                <b-col
                  v-if="showSundayRate"
                  sm="12"
                  md="12"
                  :lg="`${
                    (!showSixthDayRate && !showSeventhDayRate) || (!showSixthDayRate && showSeventhDayRate) || (showSixthDayRate && !showSeventhDayRate)
                      ? showDefaultPayCode
                        ? 3
                        : 6
                      : showDefaultPayCode
                      ? 3
                      : 4
                  }`"
                  :xl="`${
                    (!showSixthDayRate && !showSeventhDayRate) || (!showSixthDayRate && showSeventhDayRate) || (showSixthDayRate && !showSeventhDayRate)
                      ? showDefaultPayCode
                        ? 3
                        : 6
                      : showDefaultPayCode
                      ? 3
                      : 4
                  }`"
                >
                  <b-form-group v-uni-for="'sundayRate'" :label="FormMSG(102, 'Sunday and public holiday rate')">
                    <b-input-group>
                      <b-form-input
                        v-model="contract.sundayPublicHolidayFactor"
                        v-uni-id="'sundayRate'"
                        :disabled="isEditable() === false"
                        type="number"
                        step="0.000001"
                        min="0"
                        placeholder="0"
                      />
                      <b-input-group-append>
                        <b-input-group-text>
                          <percent color="#06263E" :size="16" class="icon" />
                        </b-input-group-text>
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                </b-col>
                <b-col v-if="showDefaultPayCode && showSundayRate" sm="12" md="12" lg="3" xl="3" :style="`margin:${$screen.width <= 992 ? '0' : '6px 0 0 0'}`">
                  <b-form-group>
                    <label v-if="$screen.width > 992" for="sundayPayCode">&nbsp;</label>
                    <payroll-code
                      :ref="generateTextId('sundayPayCode')"
                      style-type="select"
                      :value="contract.sundayPayCode"
                      @payroll-code:input="setPayroolCodeValue($event, 'sundayPayCode')"
                      @payroll-code:reset="resetPayroolCodeValue($event, 'sundayPayCode')"
                    />
                  </b-form-group>
                </b-col>
                <b-col
                  v-if="showSixthDayRate"
                  sm="12"
                  md="12"
                  :lg="`${
                    (!showSundayRate && !showSeventhDayRate) || (!showSundayRate && showSeventhDayRate) || (showSundayRate && !showSeventhDayRate)
                      ? showDefaultPayCode
                        ? 3
                        : 6
                      : showDefaultPayCode
                      ? 3
                      : 4
                  }`"
                  :xl="`${
                    (!showSundayRate && !showSeventhDayRate) || (!showSundayRate && showSeventhDayRate) || (showSundayRate && !showSeventhDayRate)
                      ? showDefaultPayCode
                        ? 3
                        : 6
                      : showDefaultPayCode
                      ? 3
                      : 4
                  }`"
                >
                  <b-form-group v-uni-for="'sixthDay'" :label="FormMSG(100, '6th day rate')">
                    <b-input-group>
                      <b-form-input
                        v-model="contract.sixthDay"
                        v-uni-id="'sixthDay'"
                        :disabled="isEditable() === false"
                        type="number"
                        step="0.000001"
                        min="0"
                      />
                      <b-input-group-append>
                        <b-input-group-text>
                          <percent color="#06263E" :size="16" class="icon" />
                        </b-input-group-text>
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                </b-col>
                <b-col
                  v-if="showDefaultPayCode && showSixthDayRate"
                  sm="12"
                  md="12"
                  lg="3"
                  xl="3"
                  :style="`margin:${$screen.width <= 992 ? '0' : '6px 0 0 0'}`"
                >
                  <b-form-group>
                    <label v-if="$screen.width > 992" for="seventhDayPayCode">&nbsp;</label>
                    <payroll-code
                      :ref="generateTextId('seventhDayPayCode')"
                      style-type="select"
                      :value="contract.seventhDayPayCode"
                      @payroll-code:input="setPayroolCodeValue($event, 'seventhDayPayCode')"
                      @payroll-code:reset="resetPayroolCodeValue($event, 'seventhDayPayCode')"
                    />
                  </b-form-group>
                </b-col>
                <b-col
                  v-if="showSeventhDayRate"
                  sm="12"
                  md="12"
                  :lg="`${
                    (!showSixthDayRate && !showSundayRate) || (!showSixthDayRate && showSundayRate) || (showSixthDayRate && !showSundayRate)
                      ? showDefaultPayCode
                        ? 3
                        : 6
                      : showDefaultPayCode
                      ? 3
                      : 4
                  }`"
                  :xl="`${
                    (!showSixthDayRate && !showSundayRate) || (!showSixthDayRate && showSundayRate) || (showSixthDayRate && !showSundayRate)
                      ? showDefaultPayCode
                        ? 3
                        : 6
                      : showDefaultPayCode
                      ? 3
                      : 4
                  }`"
                >
                  <b-form-group v-uni-for="'seventhDay'" :label="FormMSG(101, '7th day rate')">
                    <b-input-group>
                      <b-form-input
                        v-model="contract.seventhDay"
                        v-uni-id="'seventhDay'"
                        :disabled="isEditable() === false"
                        type="number"
                        step="0.000001"
                        min="0"
                      />
                      <b-input-group-append>
                        <b-input-group-text>
                          <percent color="#06263E" :size="16" class="icon" />
                        </b-input-group-text>
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                </b-col>
                <b-col
                  v-if="showDefaultPayCode && showSeventhDayRate"
                  sm="12"
                  md="12"
                  lg="3"
                  xl="3"
                  :style="`margin:${$screen.width <= 992 ? '0' : '6px 0 0 0'}`"
                >
                  <b-form-group>
                    <label v-if="$screen.width > 992" for="sixthDayPayCode">&nbsp;</label>
                    <payroll-code
                      :ref="generateTextId('sixthDayPayCode')"
                      style-type="select"
                      :value="contract.sixthDayPayCode"
                      @payroll-code:input="setPayroolCodeValue($event, 'sixthDayPayCode')"
                      @payroll-code:reset="resetPayroolCodeValue($event, 'sixthDayPayCode')"
                    />
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col sm="12" md="12" lg="4" xl="4">
                  <b-form-group :label="FormMSG(329, 'Public holiday calendar')">
                    <b-form-select v-model="contract.publicHolidayCalendar" :options="publicHolidays" />
                  </b-form-group>
                </b-col>
              </b-row>
            </div>
          </b-collapse>
          <!-- End Special days rates -->
          <!-- Begin Lunch -->
          <div v-if="showLunch" class="card-collapsible px-0 mt-4">
            <div class="header-card-collapsible inside d-flex flex-row align-items-center bgc-grey-light cursor-pointer" @click="handleClickHeader('lunch')">
              <div class="title w-90">
                <component :is="getLucideIcon(ICONS.UTENSIL.name)" :color="ICONS.UTENSIL.color" :size="22" />
                <div class="fz-1-35 ml-3">{{ FormMSG(171, 'Lunch') }}</div>
              </div>
              <div class="cursor-pointer d-flex justify-content-end w-10">
                <component
                  :is="getLucideIcon(ICONS.CHEVRON_DOWN.name)"
                  v-if="!configAccordion['lunch'].isVisible"
                  :color="ICONS.CHEVRON_DOWN.color"
                  :size="22"
                />
                <component :is="getLucideIcon(ICONS.CHEVRON_UP.name)" v-if="configAccordion['lunch'].isVisible" :color="ICONS.CHEVRON_UP.color" :size="22" />
              </div>
            </div>
          </div>
          <b-collapse v-if="showLunch" :visible="configAccordion['lunch'].isVisible">
            <div class="content-card-collapsible inside">
              <b-row>
                <b-col sm="12" md="12" lg="6" xl="6">
                  <b-form-group v-uni-for="'lunchMinimum'" :label="FormMSG(117, 'Min lunch')">
                    <input-date-time-picker
                      :label="FormMSG(117, 'Min lunch')"
                      :uiid="'wbnh'"
                      :type="'text'"
                      :placeholder="'hh:mm'"
                      :is-submitted="isSubmitted"
                      :item="contract.lunchMinimumStr"
                      :nb-hour="rangeHour[WORKTYPE.daily]"
                      :nb-minute="rangeMinute[WORKTYPE.daily]"
                      :is-editable="() => isEditable()"
                      :field-name="'lunchMinimum'"
                      :work-type="WORKTYPE.daily"
                      @change="handleChangeHourMin"
                    />
                  </b-form-group>
                </b-col>
                <b-col v-if="showStandard()" sm="12" md="12" lg="6" xl="6">
                  <b-form-group v-uni-for="'lunchMinimumForContDay'" :label="FormMSG(217, 'Min lunch for continuous day')">
                    <input-date-time-picker
                      :label="FormMSG(217, 'Min lunch for continuous day')"
                      :uiid="'wbnh'"
                      :type="'text'"
                      :placeholder="'hh:mm'"
                      :is-submitted="isSubmitted"
                      :item="contract.lunchMinimumForContDayStr"
                      :nb-hour="rangeHour[WORKTYPE.daily]"
                      :nb-minute="rangeMinute[WORKTYPE.daily]"
                      :is-editable="() => isEditable()"
                      :field-name="'lunchMinimumForContDay'"
                      :work-type="WORKTYPE.daily"
                      @change="handleChangeHourMin"
                    />
                  </b-form-group>
                </b-col>
              </b-row>
            </div>
          </b-collapse>
          <!-- End Lunch -->
          <!-- Begin Before call time rate -->
          <div v-if="showBeforeCallTime" class="card-collapsible px-0 mt-4">
            <div
              class="header-card-collapsible inside d-flex flex-row align-items-center bgc-grey-light cursor-pointer"
              @click="handleClickHeader('before-call-time-rate')"
            >
              <div class="title w-90">
                <component :is="getLucideIcon(ICONS.ALARM_CHECK.name)" :color="ICONS.ALARM_CHECK.color" :size="22" />
                <div class="fz-1-35 ml-3">
                  {{ showStandard() ? FormMSG(172, 'Before call time rate') : FormMSG(198, 'Early shooting day rate') }}
                </div>
              </div>
              <div class="cursor-pointer d-flex justify-content-end w-10">
                <component
                  :is="getLucideIcon(ICONS.CHEVRON_DOWN.name)"
                  v-if="!configAccordion['before-call-time-rate'].isVisible"
                  :color="ICONS.CHEVRON_DOWN.color"
                  :size="22"
                />
                <component
                  :is="getLucideIcon(ICONS.CHEVRON_UP.name)"
                  v-if="configAccordion['before-call-time-rate'].isVisible"
                  :color="ICONS.CHEVRON_UP.color"
                  :size="22"
                />
              </div>
            </div>
          </div>
          <b-collapse v-if="showBeforeCallTime" :visible="configAccordion['before-call-time-rate'].isVisible">
            <div class="content-card-collapsible inside">
              <div class="sub-title-layout pb-3" style="font-size: 0.9rem; color: rgba(6, 38, 62, 0.64)">
                {{
                  FormMSG(
                    173,
                    'You can use this section to define a specific rate for the crew members who start to work before the call time during a shooting day.'
                  )
                }}
              </div>
              <b-row>
                <b-col sm="12" md="12" :lg="`${showDefaultPayCode ? 4 : 6}`" :xl="`${showDefaultPayCode ? 4 : 6}`">
                  <b-form-group v-uni-for="'beforeCallTimeRate'" :label="FormMSG(174, 'Before call time rate')">
                    <b-input-group>
                      <b-form-input
                        v-model="contract.beforeCallTimeRate"
                        v-uni-id="'beforeCallTimeRate'"
                        :disabled="isEditable() === false"
                        type="number"
                        step="0.000001"
                        min="0"
                      />
                      <b-input-group-append>
                        <b-input-group-text>
                          <percent color="#06263E" :size="16" class="icon" />
                        </b-input-group-text>
                      </b-input-group-append>
                    </b-input-group>
                    <div v-if="showStandard()" class="info-message">
                      <div><info :size="16" /></div>
                      <div class="label">
                        <span style="color: #00a09c">+</span>
                        {{ calculateAverageRate(contract.hourlyRate, contract.beforeCallTimeRate) }} {{ currencySymbol }}
                        {{ FormMSG(176, 'per hour') }}
                      </div>
                    </div>
                  </b-form-group>
                </b-col>
                <b-col class="d-flex align-items-center mb-2" sm="12" md="12" :lg="`${showDefaultPayCode ? 4 : 6}`" :xl="`${showDefaultPayCode ? 4 : 6}`">
                  <b-form-checkbox v-model="contract.ifWorkAboveDailyHours" :disabled="isEditable() === false" size="lg" class="pj-cb pb-1">
                    {{ FormMSG(177, 'Applies if worked hours above daily hours') }}
                  </b-form-checkbox>
                </b-col>
                <b-col v-if="showDefaultPayCode" sm="12" md="12" lg="4" xl="4" :style="`margin:${$screen.width <= 576 ? '0' : '6px 0 0 0'}`">
                  <label v-if="$screen.width > 576" for="beforeTimePayCode">&nbsp;</label>
                  <payroll-code
                    :ref="generateTextId('beforeTimePayCode')"
                    style-type="select"
                    :value="contract.beforeTimePayCode"
                    @payroll-code:input="setPayroolCodeValue($event, 'beforeTimePayCode')"
                    @payroll-code:reset="resetPayroolCodeValue($event, 'beforeTimePayCode')"
                  />
                </b-col>
              </b-row>
            </div>
          </b-collapse>
          <!-- End Before call time rate -->
          <!-- Begin Allowances -->
          <div class="card-collapsible px-0 mt-4">
            <div
              class="header-card-collapsible inside d-flex flex-row align-items-center bgc-grey-light cursor-pointer"
              @click="handleClickHeader('allowances')"
            >
              <div class="title w-90">
                <component :is="getLucideIcon(ICONS.AWARD.name)" :color="ICONS.AWARD.color" :size="22" />
                <div class="fz-1-35 ml-3">{{ FormMSG(178, 'Allowances') }}</div>
              </div>
              <div class="cursor-pointer d-flex justify-content-end w-10">
                <component
                  :is="getLucideIcon(ICONS.CHEVRON_DOWN.name)"
                  v-if="!configAccordion['allowances'].isVisible"
                  :color="ICONS.CHEVRON_DOWN.color"
                  :size="22"
                />
                <component
                  :is="getLucideIcon(ICONS.CHEVRON_UP.name)"
                  v-if="configAccordion['allowances'].isVisible"
                  :color="ICONS.CHEVRON_UP.color"
                  :size="22"
                />
              </div>
            </div>
          </div>
          <b-collapse :visible="configAccordion['allowances'].isVisible">
            <div class="content-card-collapsible inside">
              <div class="sub-title-layout pb-3">
                {{ FormMSG(179, 'General allowances') }}
              </div>
              <b-row>
                <b-col sm="12" md="12" lg="6" xl="6">
                  <b-row>
                    <b-col class="d-flex justify-content-end align-items-center" :class="`${$screen.width <= 576 ? 'mt-3' : ''}`" cols="2">
                      <b-form-checkbox
                        v-model="contract.useTravelDailyRate"
                        :disabled="isEditable() === false"
                        class="fix-check-allowance"
                        size="lg"
                        @change="handleAccessGeneralAllowance($event, 'kmRate')"
                      />
                    </b-col>
                    <b-col
                      :sm="`${$screen.width <= 576 ? 0 : showDefaultPayCode ? 5 : 10}`"
                      :md="`${$screen.width <= 576 ? 0 : showDefaultPayCode ? 5 : 10}`"
                      :lg="`${$screen.width <= 576 ? 0 : 5}`"
                      :xl="`${$screen.width <= 576 ? 0 : 5}`"
                      :cols="`${$screen.width <= 576 ? 10 : 0}`"
                    >
                      <input-currency
                        v-model="contract.kmRate"
                        :disabled="isEditable() === false || contract.useTravelDailyRate === false"
                        :label="`${FormMSG(107, 'Travel rate')} (/${distanceUnit})`"
                        :model-name="'contract.kmRate'"
                        :min="0"
                        :min-fraction-digits="0"
                        :max-fraction-digits="numberOfDecimals"
                        :has-element-to-append="true"
                        :element-append-choice="ELEMENT_APPEND_CHOICE.CURRENCY"
                        @input-number:value="onHandledNumber"
                      />
                    </b-col>
                    <b-col v-if="$screen.width <= 576" cols="2" />
                    <b-col
                      v-if="showDefaultPayCode"
                      :cols="`${$screen.width <= 576 ? 10 : 5}`"
                      :style="`margin:${$screen.width <= 576 ? '-20px 0 0 0' : '6px 0 0 0'}`"
                    >
                      <b-form-group>
                        <label for="travelAllowancePayCode">&nbsp;</label>
                        <payroll-code
                          :ref="generateTextId('travelAllowancePayCode')"
                          style-type="select"
                          :value="contract.travelAllowancePayCode"
                          @payroll-code:input="setPayroolCodeValue($event, 'travelAllowancePayCode')"
                          @payroll-code:reset="resetPayroolCodeValue($event, 'travelAllowancePayCode')"
                        />
                      </b-form-group>
                    </b-col>
                    <b-col
                      v-else-if="!showDefaultPayCode && $screen.width > 576"
                      :sm="`${$screen.width <= 576 ? 0 : 5}`"
                      :md="`${$screen.width <= 576 ? 0 : 5}`"
                      :lg="`${$screen.width <= 576 ? 0 : 5}`"
                      :xl="`${$screen.width <= 576 ? 0 : 5}`"
                      :cols="`${$screen.width <= 576 ? 5 : 0}`"
                    >
                    </b-col>
                  </b-row>
                </b-col>
                <b-col sm="12" md="12" lg="6" xl="6">
                  <b-row>
                    <b-col class="d-flex justify-content-end align-items-center" :class="`${$screen.width <= 576 ? 'mt-3' : ''}`" cols="2">
                      <b-form-checkbox
                        v-model="contract.useCarAllowance"
                        :disabled="isEditable() === false"
                        class="fix-check-allowance"
                        size="lg"
                        @change="handleAccessGeneralAllowance($event, 'carAllowance')"
                      />
                    </b-col>
                    <b-col
                      :sm="`${$screen.width <= 576 ? 0 : showDefaultPayCode ? 3 : 5}`"
                      :md="`${$screen.width <= 576 ? 0 : showDefaultPayCode ? 3 : 5}`"
                      :lg="`${$screen.width <= 576 ? 0 : showDefaultPayCode ? 3 : 5}`"
                      :xl="`${$screen.width <= 576 ? 0 : showDefaultPayCode ? 3 : 5}`"
                      :cols="`${$screen.width <= 576 ? 5 : 0}`"
                    >
                      <input-currency
                        v-model="contract.carAllowance"
                        :disabled="isEditable() === false || contract.useCarAllowance === false"
                        :label="FormMSG(180, 'Car')"
                        :model-name="'contract.carAllowance'"
                        :min="0"
                        :min-fraction-digits="0"
                        :max-fraction-digits="numberOfDecimals"
                        :has-element-to-append="true"
                        :element-append-choice="ELEMENT_APPEND_CHOICE.CURRENCY"
                        @input-number:value="onHandledNumber"
                      />
                    </b-col>
                    <b-col
                      :sm="`${$screen.width <= 576 ? 0 : showDefaultPayCode ? 3 : 5}`"
                      :md="`${$screen.width <= 576 ? 0 : showDefaultPayCode ? 3 : 5}`"
                      :lg="`${$screen.width <= 576 ? 0 : showDefaultPayCode ? 3 : 5}`"
                      :xl="`${$screen.width <= 576 ? 0 : showDefaultPayCode ? 3 : 5}`"
                      :cols="`${$screen.width <= 576 ? 5 : 0}`"
                      :style="`margin:${$screen.width <= 576 ? '-20px 0 0 0' : '6px 0 0 0'}`"
                    >
                      <b-form-group>
                        <label for="allowanceCarType">&nbsp;</label>
                        <b-input-group>
                          <b-form-select v-model="contract.carAllowanceRate" :disabled="isEditable() === false" :options="periodicalOptions" />
                        </b-input-group>
                      </b-form-group>
                    </b-col>
                    <b-col v-if="$screen.width <= 576" cols="2" />
                    <b-col
                      v-if="showDefaultPayCode"
                      :cols="`${$screen.width <= 576 ? 10 : showDefaultPayCode ? 4 : 5}`"
                      :style="`margin:${$screen.width <= 576 ? '-20px 0 0 0' : '6px 0 0 0'}`"
                    >
                      <b-form-group>
                        <label for="carAllowancePayCode">&nbsp;</label>
                        <payroll-code
                          :ref="generateTextId('carAllowancePayCode')"
                          style-type="select"
                          :value="contract.carAllowancePayCode"
                          @payroll-code:input="setPayroolCodeValue($event, 'carAllowancePayCode')"
                          @payroll-code:reset="resetPayroolCodeValue($event, 'carAllowancePayCode')"
                        />
                      </b-form-group>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
              <b-row>
                <b-col sm="12" md="12" lg="6" xl="6">
                  <b-row>
                    <b-col class="d-flex justify-content-end align-items-center" :class="`${$screen.width <= 576 ? 'mt-3' : ''}`" cols="2">
                      <b-form-checkbox
                        v-model="contract.usePhoneAllowance"
                        :disabled="isEditable() === false"
                        class="fix-check-allowance"
                        size="lg"
                        @change="handleAccessGeneralAllowance($event, 'phoneAllowance')"
                      />
                    </b-col>
                    <b-col
                      :sm="`${$screen.width <= 576 ? 0 : showDefaultPayCode ? 3 : 5}`"
                      :md="`${$screen.width <= 576 ? 0 : showDefaultPayCode ? 3 : 5}`"
                      :lg="`${$screen.width <= 576 ? 0 : showDefaultPayCode ? 3 : 5}`"
                      :xl="`${$screen.width <= 576 ? 0 : showDefaultPayCode ? 3 : 5}`"
                      :cols="`${$screen.width <= 576 ? 5 : 0}`"
                    >
                      <input-currency
                        v-model="contract.phoneAllowance"
                        :disabled="isEditable() === false || contract.usePhoneAllowance === false"
                        :label="FormMSG(181, 'Phone')"
                        :model-name="'contract.phoneAllowance'"
                        :min="0"
                        :min-fraction-digits="0"
                        :max-fraction-digits="numberOfDecimals"
                        :has-element-to-append="true"
                        :element-append-choice="ELEMENT_APPEND_CHOICE.CURRENCY"
                        @input-number:value="onHandledNumber"
                      />
                    </b-col>
                    <b-col
                      :sm="`${$screen.width <= 576 ? 0 : showDefaultPayCode ? 3 : 5}`"
                      :md="`${$screen.width <= 576 ? 0 : showDefaultPayCode ? 3 : 5}`"
                      :lg="`${$screen.width <= 576 ? 0 : showDefaultPayCode ? 3 : 5}`"
                      :xl="`${$screen.width <= 576 ? 0 : showDefaultPayCode ? 3 : 5}`"
                      :cols="`${$screen.width <= 576 ? 5 : 0}`"
                      :style="`margin:${$screen.width <= 576 ? '-20px 0 0 0' : '6px 0 0 0'}`"
                    >
                      <b-form-group>
                        <label for="allowancePhoneType">&nbsp;</label>
                        <b-input-group>
                          <b-form-select v-model="contract.phoneAllowanceRate" :disabled="isEditable() === false" :options="periodicalOptions" />
                        </b-input-group>
                      </b-form-group>
                    </b-col>
                    <b-col v-if="$screen.width <= 576" cols="2" />
                    <b-col
                      v-if="showDefaultPayCode"
                      :cols="`${$screen.width <= 576 ? 10 : showDefaultPayCode ? 4 : 5}`"
                      :style="`margin:${$screen.width <= 576 ? '-20px 0 0 0' : '6px 0 0 0'}`"
                    >
                      <b-form-group>
                        <label for="phoneAllowancePayCode">&nbsp;</label>
                        <payroll-code
                          :ref="generateTextId('phoneAllowancePayCode')"
                          style-type="select"
                          :value="contract.phoneAllowancePayCode"
                          @payroll-code:input="setPayroolCodeValue($event, 'phoneAllowancePayCode')"
                          @payroll-code:reset="resetPayroolCodeValue($event, 'phoneAllowancePayCode')"
                        />
                      </b-form-group>
                    </b-col>
                  </b-row>
                </b-col>
                <b-col sm="12" md="12" lg="6" xl="6">
                  <b-row>
                    <b-col class="d-flex justify-content-end align-items-center" :class="`${$screen.width <= 576 ? 'mt-3' : ''}`" cols="2">
                      <b-form-checkbox
                        v-model="contract.useComputerAllowance"
                        :disabled="isEditable() === false"
                        class="fix-check-allowance"
                        size="lg"
                        @change="handleAccessGeneralAllowance($event, 'computerAllowance')"
                      />
                    </b-col>
                    <b-col
                      :sm="`${$screen.width <= 576 ? 0 : showDefaultPayCode ? 3 : 5}`"
                      :md="`${$screen.width <= 576 ? 0 : showDefaultPayCode ? 3 : 5}`"
                      :lg="`${$screen.width <= 576 ? 0 : showDefaultPayCode ? 3 : 5}`"
                      :xl="`${$screen.width <= 576 ? 0 : showDefaultPayCode ? 3 : 5}`"
                      :cols="`${$screen.width <= 576 ? 5 : 0}`"
                    >
                      <input-currency
                        v-model="contract.computerAllowance"
                        :disabled="isEditable() === false || contract.useComputerAllowance === false"
                        :label="FormMSG(182, 'Computer')"
                        :model-name="'contract.computerAllowance'"
                        :min="0"
                        :min-fraction-digits="0"
                        :max-fraction-digits="numberOfDecimals"
                        :has-element-to-append="true"
                        :element-append-choice="ELEMENT_APPEND_CHOICE.CURRENCY"
                        @input-number:value="onHandledNumber"
                      />
                    </b-col>
                    <b-col
                      :sm="`${$screen.width <= 576 ? 0 : showDefaultPayCode ? 3 : 5}`"
                      :md="`${$screen.width <= 576 ? 0 : showDefaultPayCode ? 3 : 5}`"
                      :lg="`${$screen.width <= 576 ? 0 : showDefaultPayCode ? 3 : 5}`"
                      :xl="`${$screen.width <= 576 ? 0 : showDefaultPayCode ? 3 : 5}`"
                      :cols="`${$screen.width <= 576 ? 5 : 0}`"
                      :style="`margin:${$screen.width <= 576 ? '-20px 0 0 0' : '6px 0 0 0'}`"
                    >
                      <b-form-group>
                        <label for="allowanceComputerType">&nbsp;</label>
                        <b-input-group>
                          <b-form-select v-model="contract.computerAllowanceRate" :disabled="isEditable() === false" :options="periodicalOptions" />
                        </b-input-group>
                      </b-form-group>
                    </b-col>
                    <b-col v-if="$screen.width <= 576" cols="2" />
                    <b-col
                      v-if="showDefaultPayCode"
                      :cols="`${$screen.width <= 576 ? 10 : showDefaultPayCode ? 4 : 5}`"
                      :style="`margin:${$screen.width <= 576 ? '-20px 0 0 0' : '6px 0 0 0'}`"
                    >
                      <b-form-group>
                        <label for="computerAllowancePayCode">&nbsp;</label>
                        <payroll-code
                          :ref="generateTextId('computerAllowancePayCode')"
                          style-type="select"
                          :value="contract.computerAllowancePayCode"
                          @payroll-code:input="setPayroolCodeValue($event, 'computerAllowancePayCode')"
                          @payroll-code:reset="resetPayroolCodeValue($event, 'computerAllowancePayCode')"
                        />
                      </b-form-group>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
              <b-row>
                <b-col sm="12" md="12" lg="6" xl="6">
                  <b-row>
                    <b-col class="d-flex justify-content-end align-items-center" :class="`${$screen.width <= 576 ? 'mt-3' : ''}`" cols="2">
                      <b-form-checkbox
                        v-model="contract.useBoxKitAllowance"
                        :disabled="isEditable() === false"
                        class="fix-check-allowance"
                        size="lg"
                        @change="handleAccessGeneralAllowance($event, 'boxKitAllowance')"
                      />
                    </b-col>
                    <b-col
                      :sm="`${$screen.width <= 576 ? 0 : showDefaultPayCode ? 3 : 5}`"
                      :md="`${$screen.width <= 576 ? 0 : showDefaultPayCode ? 3 : 5}`"
                      :lg="`${$screen.width <= 576 ? 0 : showDefaultPayCode ? 3 : 5}`"
                      :xl="`${$screen.width <= 576 ? 0 : showDefaultPayCode ? 3 : 5}`"
                      :cols="`${$screen.width <= 576 ? 5 : 0}`"
                    >
                      <input-currency
                        v-model="contract.boxKitAllowance"
                        :disabled="isEditable() === false || contract.useBoxKitAllowance === false"
                        :label="FormMSG(183, 'Box kit')"
                        :model-name="'contract.boxKitAllowance'"
                        :min="0"
                        :min-fraction-digits="0"
                        :max-fraction-digits="numberOfDecimals"
                        :has-element-to-append="true"
                        :element-append-choice="ELEMENT_APPEND_CHOICE.CURRENCY"
                        @input-number:value="onHandledNumber"
                      />
                    </b-col>
                    <b-col
                      :sm="`${$screen.width <= 576 ? 0 : showDefaultPayCode ? 3 : 5}`"
                      :md="`${$screen.width <= 576 ? 0 : showDefaultPayCode ? 3 : 5}`"
                      :lg="`${$screen.width <= 576 ? 0 : showDefaultPayCode ? 3 : 5}`"
                      :xl="`${$screen.width <= 576 ? 0 : showDefaultPayCode ? 3 : 5}`"
                      :cols="`${$screen.width <= 576 ? 5 : 0}`"
                      :style="`margin:${$screen.width <= 576 ? '-20px 0 0 0' : '6px 0 0 0'}`"
                    >
                      <b-form-group>
                        <label for="allowanceBoxKitType">&nbsp;</label>
                        <b-input-group>
                          <b-form-select v-model="contract.boxKitAllowanceRate" :disabled="isEditable() === false" :options="periodicalOptions" />
                        </b-input-group>
                      </b-form-group>
                    </b-col>
                    <b-col v-if="$screen.width <= 576" cols="2" />
                    <b-col
                      v-if="showDefaultPayCode"
                      :cols="`${$screen.width <= 576 ? 10 : showDefaultPayCode ? 4 : 5}`"
                      :style="`margin:${$screen.width <= 576 ? '-20px 0 0 0' : '6px 0 0 0'}`"
                    >
                      <b-form-group>
                        <label for="boxKitAllowancePayCode">&nbsp;</label>
                        <payroll-code
                          :ref="generateTextId('boxKitAllowancePayCode')"
                          style-type="select"
                          :value="contract.boxKitAllowancePayCode"
                          @payroll-code:input="setPayroolCodeValue($event, 'boxKitAllowancePayCode')"
                          @payroll-code:reset="resetPayroolCodeValue($event, 'boxKitAllowancePayCode')"
                        />
                      </b-form-group>
                    </b-col>
                  </b-row>
                </b-col>
                <b-col sm="12" md="12" lg="6" xl="6">
                  <b-row>
                    <b-col class="d-flex justify-content-end align-items-center" :class="`${$screen.width <= 576 ? 'mt-3' : ''}`" cols="2">
                      <b-form-checkbox
                        v-model="contract.useProductionFeeAllowance"
                        :disabled="isEditable() === false"
                        class="fix-check-allowance"
                        size="lg"
                        @change="handleAccessGeneralAllowance($event, 'productionFeeAllowance')"
                      />
                    </b-col>
                    <b-col
                      :sm="`${$screen.width <= 576 ? 0 : showDefaultPayCode ? 3 : 5}`"
                      :md="`${$screen.width <= 576 ? 0 : showDefaultPayCode ? 3 : 5}`"
                      :lg="`${$screen.width <= 576 ? 0 : showDefaultPayCode ? 3 : 5}`"
                      :xl="`${$screen.width <= 576 ? 0 : showDefaultPayCode ? 3 : 5}`"
                      :cols="`${$screen.width <= 576 ? 5 : 0}`"
                    >
                      <input-currency
                        v-model="contract.productionFeeAllowance"
                        :disabled="isEditable() === false || contract.useProductionFeeAllowance === false"
                        :label="FormMSG(184, 'Production fee')"
                        :model-name="'contract.productionFeeAllowance'"
                        :min="0"
                        :min-fraction-digits="0"
                        :max-fraction-digits="numberOfDecimals"
                        :has-element-to-append="true"
                        :element-append-choice="ELEMENT_APPEND_CHOICE.CURRENCY"
                        @input-number:value="onHandledNumber"
                      />
                      <!-- <b-form-group :label="FormMSG(184, 'Production fee')" v-uni-for="'productionFeeAllowance'">
												<b-input-group>
													<b-form-input
														:disabled="isEditable() === false || contract.useProductionFeeAllowance === false"
														v-model="contract.productionFeeAllowance"
														v-uni-id="'productionFeeAllowance'"
														type="number"
														step="0.000001"
														min="0"
														placeholder="0"
													/>
													<b-input-group-append>
														<b-input-group-text>
															<currency-svg color="#06263E" opacity="0.85" width="15" height="15" />
														</b-input-group-text>
													</b-input-group-append>
												</b-input-group>
											</b-form-group> -->
                    </b-col>
                    <b-col
                      :sm="`${$screen.width <= 576 ? 0 : showDefaultPayCode ? 3 : 5}`"
                      :md="`${$screen.width <= 576 ? 0 : showDefaultPayCode ? 3 : 5}`"
                      :lg="`${$screen.width <= 576 ? 0 : showDefaultPayCode ? 3 : 5}`"
                      :xl="`${$screen.width <= 576 ? 0 : showDefaultPayCode ? 3 : 5}`"
                      :cols="`${$screen.width <= 576 ? 5 : 0}`"
                      :style="`margin:${$screen.width <= 576 ? '-20px 0 0 0' : '6px 0 0 0'}`"
                    >
                      <b-form-group>
                        <label for="productionFeeAllowanceType">&nbsp;</label>
                        <b-input-group>
                          <b-form-select v-model="contract.productionFeeAllowanceRate" :disabled="isEditable() === false" :options="periodicalOptions" />
                        </b-input-group>
                      </b-form-group>
                    </b-col>
                    <b-col v-if="$screen.width <= 576" cols="2" />
                    <b-col
                      v-if="showDefaultPayCode"
                      :cols="`${$screen.width <= 576 ? 10 : showDefaultPayCode ? 4 : 5}`"
                      :style="`margin:${$screen.width <= 576 ? '-20px 0 0 0' : '6px 0 0 0'}`"
                    >
                      <b-form-group>
                        <label for="productionFeeAllowancePayCode">&nbsp;</label>
                        <payroll-code
                          :ref="generateTextId('productionFeeAllowancePayCode')"
                          style-type="select"
                          :value="contract.productionFeeAllowancePayCode"
                          @payroll-code:input="setPayroolCodeValue($event, 'productionFeeAllowancePayCode')"
                          @payroll-code:reset="resetPayroolCodeValue($event, 'productionFeeAllowancePayCode')"
                        />
                      </b-form-group>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
              <div class="divider" />
              <div v-if="showLunchPerDiem || showHotelPerDiem || showDinnerPerDiem || showAbroadPerDiem" class="sub-title-layout pb-3">
                {{ FormMSG(185, 'Per diem allowances') }}
              </div>
              <b-row>
                <b-col v-if="showLunchPerDiem" sm="12" md="12" lg="6" xl="6">
                  <b-row>
                    <b-col class="d-flex justify-content-end align-items-center" :class="`${$screen.width <= 576 ? 'mt-3' : ''}`" cols="2">
                      <b-form-checkbox
                        v-model="contract.useLunchPerDiem"
                        :disabled="isEditable() === false"
                        class="fix-check-allowance"
                        size="lg"
                        @change="handleAccessGeneralAllowance($event, 'lunchPerDiem')"
                      />
                    </b-col>
                    <b-col
                      :sm="`${$screen.width <= 576 ? 0 : showDefaultPayCode ? 5 : 10}`"
                      :md="`${$screen.width <= 576 ? 0 : showDefaultPayCode ? 5 : 10}`"
                      :lg="`${$screen.width <= 576 ? 0 : showDefaultPayCode ? 5 : 10}`"
                      :xl="`${$screen.width <= 576 ? 0 : showDefaultPayCode ? 5 : 10}`"
                      :cols="`${$screen.width <= 576 ? 10 : 0}`"
                    >
                      <input-currency
                        v-model="contract.lunchPerDiem"
                        :disabled="isEditable() === false || contract.useLunchPerDiem === false"
                        :label="FormMSG(108, 'Lunch per diem')"
                        :model-name="'contract.lunchPerDiem'"
                        :min="0"
                        :min-fraction-digits="0"
                        :max-fraction-digits="numberOfDecimals"
                        :has-element-to-append="true"
                        :element-append-choice="ELEMENT_APPEND_CHOICE.CURRENCY"
                        @input-number:value="onHandledNumber"
                      />
                    </b-col>
                    <b-col v-if="$screen.width <= 576" cols="2" />
                    <b-col
                      v-if="showDefaultPayCode"
                      :cols="`${$screen.width <= 576 ? 10 : showDefaultPayCode ? 5 : 10}`"
                      :style="`margin:${$screen.width <= 576 ? '-20px 0 0 0' : '6px 0 0 0'}`"
                    >
                      <b-form-group>
                        <label for="lunchPerDiemPayCode">&nbsp;</label>
                        <payroll-code
                          :ref="generateTextId('lunchPerDiemPayCode')"
                          style-type="select"
                          :value="contract.lunchPerDiemPayCode"
                          @payroll-code:input="setPayroolCodeValue($event, 'lunchPerDiemPayCode')"
                          @payroll-code:reset="resetPayroolCodeValue($event, 'lunchPerDiemPayCode')"
                        />
                      </b-form-group>
                    </b-col>
                  </b-row>
                </b-col>
                <b-col v-if="showDinnerPerDiem" sm="12" md="12" lg="6" xl="6">
                  <b-row>
                    <b-col class="d-flex justify-content-end align-items-center" :class="`${$screen.width <= 576 ? 'mt-3' : ''}`" cols="2">
                      <b-form-checkbox
                        v-model="contract.useDinnerPerDiem"
                        :disabled="isEditable() === false"
                        class="fix-check-allowance"
                        size="lg"
                        @change="handleAccessGeneralAllowance($event, 'dinnerPerDiem')"
                      />
                    </b-col>
                    <b-col
                      :sm="`${$screen.width <= 576 ? 0 : showDefaultPayCode ? 5 : 10}`"
                      :md="`${$screen.width <= 576 ? 0 : showDefaultPayCode ? 5 : 10}`"
                      :lg="`${$screen.width <= 576 ? 0 : showDefaultPayCode ? 5 : 10}`"
                      :xl="`${$screen.width <= 576 ? 0 : showDefaultPayCode ? 5 : 10}`"
                      :cols="`${$screen.width <= 576 ? 10 : 0}`"
                    >
                      <input-currency
                        v-model="contract.dinnerPerDiem"
                        :disabled="isEditable() === false || contract.useDinnerPerDiem === false"
                        :label="FormMSG(186, 'Diner per diem')"
                        :model-name="'contract.dinnerPerDiem'"
                        :min="0"
                        :min-fraction-digits="0"
                        :max-fraction-digits="numberOfDecimals"
                        :has-element-to-append="true"
                        :element-append-choice="ELEMENT_APPEND_CHOICE.CURRENCY"
                        @input-number:value="onHandledNumber"
                      />
                    </b-col>
                    <b-col v-if="$screen.width <= 576" cols="2" />
                    <b-col
                      v-if="showDefaultPayCode"
                      :cols="`${$screen.width <= 576 ? 10 : showDefaultPayCode ? 5 : 10}`"
                      :style="`margin:${$screen.width <= 576 ? '-20px 0 0 0' : '6px 0 0 0'}`"
                    >
                      <b-form-group>
                        <label for="dinerPerDiemPayCode">&nbsp;</label>
                        <payroll-code
                          :ref="generateTextId('dinerPerDiemPayCode')"
                          style-type="select"
                          :value="contract.dinerPerDiemPayCode"
                          @payroll-code:input="setPayroolCodeValue($event, 'dinerPerDiemPayCode')"
                          @payroll-code:reset="resetPayroolCodeValue($event, 'dinerPerDiemPayCode')"
                        />
                      </b-form-group>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
              <b-row>
                <b-col v-if="showHotelPerDiem" sm="12" md="12" lg="6" xl="6">
                  <b-row>
                    <b-col class="d-flex justify-content-end align-items-center" :class="`${$screen.width <= 576 ? 'mt-3' : ''}`" cols="2">
                      <b-form-checkbox
                        v-model="contract.useHotelPerDiem"
                        :disabled="isEditable() === false"
                        class="fix-check-allowance"
                        size="lg"
                        @change="handleAccessGeneralAllowance($event, 'hotelPerDiem')"
                      />
                    </b-col>
                    <b-col
                      :sm="`${$screen.width <= 576 ? 0 : showDefaultPayCode ? 5 : 10}`"
                      :md="`${$screen.width <= 576 ? 0 : showDefaultPayCode ? 5 : 10}`"
                      :lg="`${$screen.width <= 576 ? 0 : showDefaultPayCode ? 5 : 10}`"
                      :xl="`${$screen.width <= 576 ? 0 : showDefaultPayCode ? 5 : 10}`"
                      :cols="`${$screen.width <= 576 ? 10 : 0}`"
                    >
                      <input-currency
                        v-model="contract.hotelPerDiem"
                        :disabled="isEditable() === false || contract.useHotelPerDiem === false"
                        :label="FormMSG(109, 'Hotel per diem')"
                        :model-name="'contract.hotelPerDiem'"
                        :min="0"
                        :min-fraction-digits="0"
                        :max-fraction-digits="numberOfDecimals"
                        :has-element-to-append="true"
                        :element-append-choice="ELEMENT_APPEND_CHOICE.CURRENCY"
                        @input-number:value="onHandledNumber"
                      />
                    </b-col>
                    <b-col v-if="$screen.width <= 576" cols="2" />
                    <b-col
                      v-if="showDefaultPayCode"
                      :cols="`${$screen.width <= 576 ? 10 : showDefaultPayCode ? 5 : 10}`"
                      :style="`margin:${$screen.width <= 576 ? '-20px 0 0 0' : '6px 0 0 0'}`"
                    >
                      <b-form-group>
                        <label for="hotelPerDiemPayCode">&nbsp;</label>
                        <payroll-code
                          :ref="generateTextId('hotelPerDiemPayCode')"
                          style-type="select"
                          :value="contract.hotelPerDiemPayCode"
                          @payroll-code:input="setPayroolCodeValue($event, 'hotelPerDiemPayCode')"
                          @payroll-code:reset="resetPayroolCodeValue($event, 'hotelPerDiemPayCode')"
                        />
                      </b-form-group>
                    </b-col>
                  </b-row>
                </b-col>
                <b-col v-if="showAbroadPerDiem" sm="12" md="12" lg="6" xl="6">
                  <b-row>
                    <b-col class="d-flex justify-content-end align-items-center" :class="`${$screen.width <= 576 ? 'mt-3' : ''}`" cols="2">
                      <b-form-checkbox
                        v-model="contract.useAbroadPerDiem"
                        :disabled="isEditable() === false"
                        class="fix-check-allowance"
                        size="lg"
                        @change="handleAccessGeneralAllowance($event, 'abroadPerDiem')"
                      />
                    </b-col>
                    <b-col
                      :sm="`${$screen.width <= 576 ? 0 : showDefaultPayCode ? 5 : 10}`"
                      :md="`${$screen.width <= 576 ? 0 : showDefaultPayCode ? 5 : 10}`"
                      :lg="`${$screen.width <= 576 ? 0 : showDefaultPayCode ? 5 : 10}`"
                      :xl="`${$screen.width <= 576 ? 0 : showDefaultPayCode ? 5 : 10}`"
                      :cols="`${$screen.width <= 576 ? 10 : 0}`"
                    >
                      <input-currency
                        v-model="contract.abroadPerDiem"
                        :disabled="isEditable() === false || contract.useAbroadPerDiem === false"
                        :label="FormMSG(187, 'Abroad per diem')"
                        :model-name="'contract.abroadPerDiem'"
                        :min="0"
                        :min-fraction-digits="0"
                        :max-fraction-digits="numberOfDecimals"
                        :has-element-to-append="true"
                        :element-append-choice="ELEMENT_APPEND_CHOICE.CURRENCY"
                        @input-number:value="onHandledNumber"
                      />
                    </b-col>
                    <b-col v-if="$screen.width <= 576" cols="2" />
                    <b-col
                      v-if="showDefaultPayCode"
                      :cols="`${$screen.width <= 576 ? 10 : showDefaultPayCode ? 5 : 10}`"
                      :style="`margin:${$screen.width <= 576 ? '-20px 0 0 0' : '6px 0 0 0'}`"
                    >
                      <b-form-group>
                        <label for="abroadPerDiemPayCode">&nbsp;</label>
                        <payroll-code
                          :ref="generateTextId('abroadPerDiemPayCode')"
                          style-type="select"
                          :value="contract.abroadPerDiemPayCode"
                          @payroll-code:input="setPayroolCodeValue($event, 'abroadPerDiemPayCode')"
                          @payroll-code:reset="resetPayroolCodeValue($event, 'abroadPerDiemPayCode')"
                        />
                      </b-form-group>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
            </div>
          </b-collapse>
          <!-- End Allowances -->
          <!-- Begin Note -->
          <div class="card-collapsible px-0 mt-4">
            <div class="header-card-collapsible inside d-flex flex-row align-items-center bgc-grey-light cursor-pointer" @click="handleClickHeader('note')">
              <div class="title w-90">
                <component :is="getLucideIcon(ICONS.MENU.name)" :color="ICONS.MENU.color" :size="22" />
                <div class="fz-1-35 ml-3">{{ FormMSG(188, 'Note') }}</div>
              </div>
              <div class="cursor-pointer d-flex justify-content-end w-10">
                <component
                  :is="getLucideIcon(ICONS.CHEVRON_DOWN.name)"
                  v-if="!configAccordion['note'].isVisible"
                  :color="ICONS.CHEVRON_DOWN.color"
                  :size="22"
                />
                <component :is="getLucideIcon(ICONS.CHEVRON_UP.name)" v-if="configAccordion['note'].isVisible" :color="ICONS.CHEVRON_UP.color" :size="22" />
              </div>
            </div>
          </div>
          <b-collapse :visible="configAccordion['note'].isVisible">
            <div class="content-card-collapsible inside">
              <b-row>
                <b-col sm="3" md="3" lg="3" xl="3">
                  <b-row>
                    <b-col cols="12">
                      <b-form-group v-uni-for="'contractType'" :label="FormMSG(304, 'Contract type')">
                        <b-form-input
                          v-model="contract.contractType"
                          v-uni-id="'contractType'"
                          :disabled="isEditable() === false"
                          type="text"
                          autocomplete="off"
                          :placeholder="FormMSG(305, 'Your contract type ...')"
                        />
                      </b-form-group>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col cols="12">
                      <b-form-group v-uni-for="'misc'" :label="FormMSG(296, 'Misc.')">
                        <b-form-input
                          v-model="contract.contractReference"
                          v-uni-id="'misc'"
                          :disabled="isEditable() === false"
                          type="text"
                          autocomplete="off"
                          :placeholder="FormMSG(297, 'Your contract reference ...')"
                        />
                      </b-form-group>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col cols="12">
                      <b-form-group v-uni-for="'collectiveAgreement'" :label="FormMSG(314, 'Collective agreement code')">
                        <b-form-input
                          v-model="contract.collectiveAgreement"
                          v-uni-id="'collectiveAgreement'"
                          :disabled="isEditable() === false"
                          type="text"
                          autocomplete="off"
                          :placeholder="FormMSG(315, 'Your collective agreement code ...')"
                        />
                      </b-form-group>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col cols="12">
                      <b-form-group v-uni-for="'echelon'" :label="FormMSG(316, 'Echelon')">
                        <b-form-input
                          v-model="contract.echelon"
                          v-uni-id="'echelon'"
                          :disabled="isEditable() === false"
                          type="text"
                          autocomplete="off"
                          :placeholder="FormMSG(317, 'Your echelon ...')"
                        />
                      </b-form-group>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col cols="12">
                      <b-form-group v-uni-for="'analyticCode'" :label="FormMSG(318, 'Analytic code')">
                        <b-form-input
                          v-model="contract.analyticCode"
                          v-uni-id="'analyticCode'"
                          :disabled="isEditable() === false"
                          type="text"
                          autocomplete="off"
                          :placeholder="FormMSG(319, 'Your analytic code ...')"
                        />
                      </b-form-group>
                    </b-col>
                  </b-row>
                </b-col>
                <b-col sm="9" md="9" lg="9" xl="9">
                  <b-form-group v-uni-for="'note'">
                    <b-form-textarea
                      id="note"
                      v-model="contract.note"
                      :disabled="isEditable() === false"
                      type="textarea"
                      :rows="`${$screen.width <= 576 ? 6 : 17}`"
                      :placeholder="FormMSG(189, 'Enter a note here ...')"
                      autocomplete="off"
                      class="pb-2"
                    />
                  </b-form-group>
                </b-col>
              </b-row>
              <!-- <pre>{{ canEditCustomField }} - {{ routeName }}</pre> -->
              <b-row v-if="canEditCustomField">
                <b-col>
                  <div class="divider"></div>
                  <div class="sub-title">{{ FormMSG(330, 'Custom fields') }}</div>
                  <div class="content-card-collapsible">
                    <b-row class="pb-2">
                      <!-- <pre>{{ customFields }}</pre> -->
                      <!-- <pre>{{ customFieldModels }}</pre> -->
                      <b-col
                        v-for="(customField, index) in customFields"
                        :key="index"
                        :xl="sizeFlagInput(customFields.length)"
                        :lg="sizeFlagInput(customFields.length)"
                        class="d-flex mb-2 w-100"
                      >
                        <custom-field-template
                          v-model="customField[customFieldModels[index]]"
                          :field="customField"
                          :name-model="customFieldModels[index]"
                          :name-group="customField.nameGroup"
                          :index="index"
                          class="w-100"
                          @custom-field-template:payload="onFieldTemplateChanged"
                        />
                      </b-col>
                    </b-row>
                  </div>
                  <div v-if="isEditable()" class="card-collapsible pb-1">
                    <div class="d-flex flex-row align-items-center">
                      <b-button
                        size="md"
                        variant="outline-primary"
                        class="w-270-px d-flex justify-content-center align-items-center"
                        block
                        @click="manageCustomFields"
                      >
                        <component :is="getLucideIcon('PlusCircle')" :size="20" :stroke-width="2.5" />
                        <div class="px-2" style="margin-bottom: 0px">
                          {{ FormMSG(331, 'Add/Edit Custom Fields') }}
                        </div>
                      </b-button>
                    </div>
                  </div>
                </b-col>
              </b-row>
            </div>
          </b-collapse>
          <!-- End Note -->
        </div>
      </b-collapse>
    </div>
    <div v-if="!isFilmSingleUserFree && !isFilmSingleUser && !hideActions" class="px-4 pt-3">
      <b-row class="d-flex justify-content-center align-items-center" :class="`${$screen.width <= 576 ? 'footer-fixed' : ''}`">
        <b-col sm="12" md="12" lg="4" xl="4">
          <b-button size="md" variant="outline-secondary" class="px-4" block @click="copyContract">
            {{ FormMSG(192, 'Copy deal memo') }}
          </b-button>
        </b-col>
        <b-col sm="12" md="12" lg="4" xl="4" :class="`${$screen.width <= 992 ? 'my-2' : ''}`">
          <b-button size="md" variant="outline-secondary" class="px-4" :disabled="contractCopied === 0" block @click="pasteContract">
            {{ FormMSG(193, 'Paste deal memo') }}
          </b-button>
        </b-col>
        <b-col sm="12" md="12" lg="4" xl="4">
          <b-button size="md" variant="outline-secondary" class="px-4" :disabled="disableSaveDealMemoTemplate" block @click="saveAsDealMemoTemplate($event)">
            {{ FormMSG(194, 'Save as deal memo template') }}
          </b-button>
        </b-col>
      </b-row>
    </div>
    <custom-field-modal
      ref="contractCustomField"
      v-model="isCustomFieldModalOpen"
      :parent-type="defaultCustomFieldParentType"
      @custom-field-main-modal:closed="onCustomFieldMainModalClosed"
      @custom-field-main-modal:reload="onCustomFieldMainModalReloaded"
    />
  </div>
</template>

<script>
import { isNil, omit, generateSecureId } from '@/shared/utils';
import languageMessages from '@/mixins/languageMessages';
import { createUniqIdsMixin } from 'vue-uniq-ids';
const uniqIdsMixin = createUniqIdsMixin(/* options */);
import { Euro, Info, Percent, AlarmPlus, Bus, Award, Moon } from 'lucide-vue';
import isSingleProjectMixin from '@/mixins/isSingleProject.mixin';
import { store } from '@/store';
import CurrencySvg from '@/components/Svg/Currency';
import { validationMixin } from 'vuelidate';
import globalMixin from '@/mixins/global.mixin';
import InputDateTimePicker from '@/components/InputDateTimePicker/InputDateTimePicker';
import { useWorktype, useRangeHour, useRangeMinute } from '../utils/utils';
import PayrollCode from '@/components/Spaiectacle/PayrollCode';
import { dataCcn2642 } from '@/cruds/contract.crud';
import { getProjectPublicHolidayCalendar } from '@/cruds/holidays.crud';
import * as _ from 'lodash';
import CustomFieldModal from '@/components/CustomField/MainModal';
import { CUSTOM_FIELD_PARENT_TYPE, CUSTOM_FIELD_TYPE, ROUTE_NAME, ELEMENT_APPEND_CHOICE, DEFAULT_CONTRACT_TEMPLATE } from '@/shared/constants';
import { getCustomFields } from '@/cruds/custom-field.crud';
import CustomFieldTemplate from '@/components/CustomField/CustomFieldTemplate';
import InputCurrency from '@/components/Input/InputNumber';
import { mapGetters } from 'vuex';
import moment from 'moment';

export default {
  // Lanja: Allow only non-PascalCase Component name for this component because too many translation was already done here.
  // eslint-disable-next-line vue/component-definition-name-casing
  name: 'memoDealVue',
  components: {
    Euro,
    Info,
    Percent,
    AlarmPlus,
    Bus,
    Award,
    Moon,
    CurrencySvg,
    InputDateTimePicker,
    PayrollCode,
    CustomFieldModal,
    CustomFieldTemplate,
    InputCurrency
  },
  mixins: [languageMessages, uniqIdsMixin, isSingleProjectMixin, validationMixin, globalMixin],
  props: {
    disableEdit: {
      type: Boolean,
      required: false,
      default: false
    },
    disableSave: {
      type: Number,
      required: false,
      default: 0
    },
    editData: {
      type: Object,
      required: false,
      default: null
    },
    displayCopyPaste: {
      type: Boolean,
      required: false,
      default: false
    },
    startDateUpdate: {
      type: [String, Date],
      required: false,
      default: null
    },
    endDateUpdate: {
      type: [String, Date],
      required: false,
      default: null
    },
    daysForeseenUpdate: {
      type: [String, Number],
      required: false,
      default: '0'
    },
    employeeStatusUpdate: {
      type: [String, Number],
      required: false,
      default: '0'
    },
    costCenterPrepsTypeUpdate: {
      type: [String, Number],
      required: false,
      default: '0'
    },
    costCenterShootingTypeUpdate: {
      type: [String, Number],
      required: false,
      default: '0'
    },
    costCenterWrapTypeUpdate: {
      type: [String, Number],
      required: false,
      default: '0'
    },
    companyCostFactorUpdate: {
      type: [String, Number],
      required: false,
      default: '0'
    },
    documentPackageIdUpdate: {
      type: [String, Number],
      required: false,
      default: '0'
    },
    isSubmitted: {
      type: Boolean,
      required: false,
      default: false
    },
    fillClassContainer: {
      type: String,
      required: false,
      default: 'container-layout' // default empty, or 'container-layout'
    },
    disableSaveDealMemoTemplate: {
      type: Boolean,
      required: false,
      default: false
    },
    hideActions: {
      type: Boolean,
      required: false,
      default: false
    },
    isAutomaticSentContractUpdate: {
      type: Boolean,
      required: false,
      default: false
    },
    showPayCode: {
      type: Boolean,
      required: false,
      default: false
    },
    userId: {
      type: [String, Number],
      required: false,
      default: 0
    }
  },
  data() {
    return {
      cloneWeeklyFiveDaysRefSalaryWithDecimal: null,
      cloneWeeklyFiveDaysRefSalary: null,
      contractCopied: 0,
      smgBase: 0,
      showDateTimePickers: false,
      rangeHour: {},
      rangeMinute: {},
      WORKTYPE: {},
      contract: { ...DEFAULT_CONTRACT_TEMPLATE },
      contractContent: {},
      showTooltipBcf: false,
      configAccordion: {
        'work-details': {
          isVisible: true
        },
        'main-details': {
          isVisible: true
        },
        overtimes: {
          isVisible: false
        },
        'night-time': {
          isVisible: false
        },
        'rest-time': {
          isVisible: false
        },
        transport: {
          isVisible: false
        },
        'special-days-rates': {
          isVisible: false
        },
        lunch: {
          isVisible: false
        },
        'before-call-time-rate': {
          isVisible: false
        },
        allowances: {
          isVisible: false
        },
        note: {
          isVisible: true
        },
        'work-info': {
          isVisible: true
        }
      },
      localSubmitted: false,
      standardPayCodeTitle: '',
      showDefaultPayCode: true,
      publicHolidays: [],
      isCustomFieldModalOpen: false,
      CUSTOM_FIELD_PARENT_TYPE,
      defaultCustomFieldParentType: CUSTOM_FIELD_PARENT_TYPE.contract,
      customFields: [],
      customFieldModels: [],
      customFieldValueInputs: [],
      routeName: null,
      ELEMENT_APPEND_CHOICE
    };
  },
  computed: {
    ...mapGetters({
      currentJobRequestProject: 'job-request/currentJobRequestProject'
    }),
    cnn2642Options() {
      return this.FormMenu(10006);
    },
    optionsForDefaultDayType() {
      return this.FormMenu(1010);
    },
    optionsForTimeManagementType() {
      return this.FormMenu(1117);
    },
    optionsForNumDays() {
      return this.FormMenu(1118);
    },
    isFilmSingleUserFree() {
      return store.isFilmSingleUserFree();
    },
    isFilmSingleUser() {
      return store.isFilmSingleUser();
    },
    distanceUnit() {
      return store.state.myProfile.distanceUnit;
    },
    currencySymbol() {
      return store.state.myProfile.currencySymbol;
    },
    periodicalOptions() {
      return this.FormMenu(1333);
    },
    partialPeriodicalOptions() {
      return this.FormMenu(1332);
    },
    canEditCustomField() {
      return this.routeName !== ROUTE_NAME.jobRequestDetail && this.routeName !== ROUTE_NAME.configProjectAdmin;
    },
    isFromJobRequest() {
      return this.routeName === ROUTE_NAME.jobRequestDetail;
    },
    isUserProfile() {
      return this.routeName === ROUTE_NAME.profile;
    },
    showOvt() {
      if (this.isFromJobRequest && this.currentJobRequestProject) return this.currentJobRequestProject.useOvertime;
      return this.getProjectConfigProperty('useOvertime');
    },
    showOvt1() {
      if (this.isFromJobRequest && this.currentJobRequestProject) return this.currentJobRequestProject.useOvt1;
      return this.getProjectConfigProperty('useOvt1');
    },
    showOvt2() {
      if (this.isFromJobRequest && this.currentJobRequestProject) return this.currentJobRequestProject.useOvt2;
      return this.getProjectConfigProperty('useOvt2');
    },
    showNightHours() {
      if (this.isFromJobRequest && this.currentJobRequestProject) return this.currentJobRequestProject.useNightHours;
      return this.getProjectConfigProperty('useNightHours');
    },
    showTooEarlyHours() {
      if (this.isFromJobRequest && this.currentJobRequestProject) return this.currentJobRequestProject.useTooEarlyHours;
      return this.getProjectConfigProperty('useTooEarlyHours');
    },
    showTransport() {
      if (this.isFromJobRequest && this.currentJobRequestProject) return this.currentJobRequestProject.useHomeToWorkTime;
      return this.getProjectConfigProperty('useHomeToWorkTime');
    },
    showLunch() {
      if (this.isFromJobRequest && this.currentJobRequestProject) return this.currentJobRequestProject.useLunchTime;
      return this.getProjectConfigProperty('useLunchTime');
    },
    showBeforeCallTime() {
      if (this.isFromJobRequest && this.currentJobRequestProject) return this.currentJobRequestProject.useBeforeCallTime;
      return this.getProjectConfigProperty('useBeforeCallTime');
    },
    showWeeklyOvt() {
      if (this.isFromJobRequest && this.currentJobRequestProject) return this.currentJobRequestProject.useWeeklyOvt;
      return this.getProjectConfigProperty('useWeeklyOvt');
    },
    showWeeklyOvt1() {
      if (this.isFromJobRequest && this.currentJobRequestProject) return this.currentJobRequestProject.useWeeklyOvt1;
      return this.getProjectConfigProperty('useWeeklyOvt1');
    },
    showWeeklyOvt2() {
      if (this.isFromJobRequest && this.currentJobRequestProject) return this.currentJobRequestProject.useWeeklyOvt2;
      return this.getProjectConfigProperty('useWeeklyOvt2');
    },
    showSixthDayRate() {
      if (this.isFromJobRequest && this.currentJobRequestProject) return this.currentJobRequestProject.useSixthDay;
      return this.getProjectConfigProperty('useSixthDay');
    },
    showSeventhDayRate() {
      if (this.isFromJobRequest && this.currentJobRequestProject) return this.currentJobRequestProject.useSeventhDay;
      return this.getProjectConfigProperty('useSeventhDay');
    },
    showSundayRate() {
      if (this.isFromJobRequest && this.currentJobRequestProject) return this.currentJobRequestProject.useSundayRate;
      return this.getProjectConfigProperty('useSundayRate');
    },
    showLunchPerDiem() {
      if (this.isFromJobRequest && this.currentJobRequestProject) return this.currentJobRequestProject.useLunchPerDiem;
      return this.getProjectConfigProperty('useLunchPerDiem');
    },
    showHotelPerDiem() {
      if (this.isFromJobRequest && this.currentJobRequestProject) return this.currentJobRequestProject.useHotelPerDiem;
      return this.getProjectConfigProperty('useHotelPerDiem');
    },
    showDinnerPerDiem() {
      if (this.isFromJobRequest && this.currentJobRequestProject) return this.currentJobRequestProject.useDinnerPerDiem;
      return this.getProjectConfigProperty('useDinnerPerDiem');
    },
    showAbroadPerDiem() {
      if (this.isFromJobRequest && this.currentJobRequestProject) return this.currentJobRequestProject.useAbroadPerDiem;
      return this.getProjectConfigProperty('useAbroadPerDiem');
    },
    numberOfDecimals() {
      if (this.isFromJobRequest && this.currentJobRequestProject) return this.currentJobRequestProject.contractHourlyRatePrecision;
      return this.getProjectConfigProperty('contractHourlyRatePrecision');
    }
  },
  watch: {
    contract: {
      handler(value) {
        if (!isNil(value)) {
          let contract = this.validateFields(value);

          const time = /(\d{2}:\d{2}:\d{2})/g;

          contract.nightTimeStart =
            value.nightTimeStart.match(time) && contract.nightTimeStart.match(time).length > 0
              ? contract.nightTimeStart.match(time)[0]
              : `${contract.nightTimeStart}:00`;

          contract.nightTimeEnd =
            contract.nightTimeEnd.match(time) && contract.nightTimeEnd.match(time).length > 0
              ? contract.nightTimeEnd.match(time)[0]
              : `${contract.nightTimeEnd}:00`;

          contract.minTimeBetweenDays =
            contract.minTimeBetweenDays.match(time) && contract.minTimeBetweenDays.match(time).length > 0
              ? contract.minTimeBetweenDays.match(time)[0]
              : `${contract.minTimeBetweenDays}:00`;

          // fix for old values not updating
          if (!contract.useTravelDailyRate && parseFloat(contract.kmRate) > 0) {
            contract.useTravelDailyRate = !contract.useTravelDailyRate;
          }

          // contract.publicHolidayCalendar = contract.publicHolidayCalendar;

          setTimeout(() => {
            this.getStandardPayCodeTitle(contract.defaultDayType);
          }, 250);

          this.$emit('change', contract);
        }
      },
      deep: true
      // immediate: true
    },
    startDateUpdate: {
      handler(n) {
        if (!isNil(n)) {
          this.contract = {
            ...this.contract,
            startDate: n
          };
        }
      },
      deep: true
    },
    endDateUpdate: {
      handler(n) {
        if (!isNil(n)) {
          this.contract = {
            ...this.contract,
            endDate: n
          };
        }
      },
      deep: true
      // immediate: true
    },
    daysForeseenUpdate: {
      handler(n) {
        if (!isNil(n)) {
          this.contract = {
            ...this.contract,
            daysForeseen: n
          };
        }
      },
      deep: true
      // immediate: true
    },
    employeeStatusUpdate: {
      handler(n) {
        if (!isNil(n)) {
          this.contract = {
            ...this.contract,
            employeeStatus: n
          };
        }
      },
      deep: true
      // immediate: true
    },
    costCenterPrepsTypeUpdate: {
      handler(n) {
        if (!isNil(n)) {
          this.contract = {
            ...this.contract,
            costCenterPrepsType: n
          };
        }
      },
      deep: true
      // immediate: true
    },
    costCenterShootingTypeUpdate: {
      handler(n) {
        if (!isNil(n)) {
          this.contract = {
            ...this.contract,
            costCenterShootingType: n
          };
        }
      },
      deep: true
      // immediate: true
    },
    costCenterWrapTypeUpdate: {
      handler(n) {
        if (!isNil(n)) {
          this.contract = {
            ...this.contract,
            costCenterWrapType: n
          };
        }
      },
      deep: true
      // immediate: true
    },
    companyCostFactorUpdate: {
      handler(n) {
        if (!isNil(n)) {
          this.contract = {
            ...this.contract,
            companyCostFactor: n
          };
        }
      },
      deep: true
      // immediate: true
    },
    documentPackageIdUpdate: {
      handler(n) {
        if (!isNil(n)) {
          this.contract = {
            ...this.contract,
            documentPackageId: n
          };
        }
      },
      deep: true
      // immediate: true
    },
    isSubmitted: {
      handler(n) {
        if (!isNil(n) && n === true) {
          // this.$v.$touch();
          // if (this.$v.$invalid) {
          // 	this.$emit('memo-deal:fields:invalid', true);
          // } else {
          // 	this.$emit('memo-deal:fields:invalid', false);
          // }
        }
      },
      deep: true,
      immediate: true
    },
    isAutomaticSentContractUpdate: {
      handler(n) {
        if (!isNil(n)) {
          this.contract = {
            ...this.contract,
            isAutomaticSentContract: n
          };
        }
      },
      deep: true
      // immediate: true
    },
    showPayCode: {
      handler(value) {
        if (!isNil(value)) {
          this.showDefaultPayCode = /*this.showStandard() && */ value;
        }
      },
      deep: true,
      immediate: true
    },
    '$route.name': {
      handler(value) {
        if (!_.isNil(value)) {
          this.routeName = value;
        }
      },
      deep: true,
      immediate: true
    }
  },
  async created() {
    this.loadEditDataToContract();
    this.setActionInputDateTimePicker();
    await this.getPublicHolidays();
  },
  async mounted() {
    if (this.canEditCustomField) {
      this.customFields = await this.customFieldList();
      // console.log({ customFields: this.customFields });
    }
  },
  methods: {
    handleGuaranteedType(event) {
      this.contract.minimumHourGuaranteedType = event;
    },
    setActionInputDateTimePicker() {
      this.WORKTYPE = useWorktype;
      this.rangeHour = useRangeHour;
      this.rangeMinute = useRangeMinute;
    },
    handleChangeHourMin(payload) {
      // console.log(payload);
      this.contract[payload.fieldName + 'Str'] = payload.hourValid;
      this.convertHourMinuteToInt(payload);
    },
    convertHourMinuteToInt(payload) {
      const fieldName = payload.fieldName;
      const fieldNameStr = fieldName + 'Str';
      this.contract[fieldNameStr] = payload.hourValid;
      if (
        this.contract[fieldNameStr].split(':').length == 2 &&
        isNaN(parseInt(this.contract[fieldNameStr].split(':')[0], 10)) == false &&
        isNaN(parseInt(this.contract[fieldNameStr].split(':')[1], 10)) == false
      ) {
        this.contract[fieldName] = parseInt(this.contract[fieldNameStr].split(':')[0], 10) * 60 + parseInt(this.contract[fieldNameStr].split(':')[1], 10);
      } else {
        this.contract[fieldName] = 0;
      }
    },
    computeSalaryFromEffNumHours(numHours, hourlyRate) {
      let leftToCredit = numHours;
      let salary = 0;
      if (leftToCredit > this.contract.weeklyOvtThreeLimit / 60) {
        salary += ((hourlyRate * this.contract.weeklyOvtThreeRate) / 100) * (leftToCredit - this.contract.weeklyOvtThreeLimit / 60);
        leftToCredit = this.contract.weeklyOvtThreeLimit / 60;
      }
      if (leftToCredit > this.contract.weeklyOvtTwoLimit / 60) {
        salary += ((hourlyRate * this.contract.weeklyOvtTwoRate) / 100) * (leftToCredit - this.contract.weeklyOvtTwoLimit / 60);
        leftToCredit = this.contract.weeklyOvtTwoLimit / 60;
      }
      if (leftToCredit > this.contract.weeklyOvtOneLimit / 60) {
        salary += ((hourlyRate * this.contract.weeklyOvtOneRate) / 100) * (leftToCredit - this.contract.weeklyOvtOneLimit / 60);
        leftToCredit = this.contract.weeklyOvtOneLimit / 60;
      }
      salary += hourlyRate * (this.contract.weeklyOvtOneLimit / 60);

      return salary;
    },
    computeSMG(payload) {
      //console.log("in compute smg1:",this.showCCNAnnex1());
      if (this.showCCNAnnex1()) {
        if (this.showBaseDays()) {
          this.smgBase = this.computeSalaryFromEffNumHours(this.contract.weeklyBaseEffNumHours, this.contract.hourlyRate);
        } else if (this.showFiveDays()) {
          this.contract.weeklyFiveDaysMinimumSalary = this.computeSalaryFromEffNumHours(this.contract.weeklyFiveDaysEffNumHours, this.contract.hourlyRate);
        } else if (this.showSixDays()) {
          this.contract.weeklySixDaysMinimumSalary = this.computeSalaryFromEffNumHours(this.contract.weeklySixDaysEffNumHours, this.contract.hourlyRate);
        }
      } else if (this.showCCNAnnex3()) {
        if (this.showBaseDays()) {
          this.contract.weeklyBaseMinimumSalary = this.computeSalaryFromEffNumHours(this.contract.weeklyBaseEffNumHours, this.contract.hourlyRateAnnexThree);
          //  console.log("in compute smg:",this.contract.hourlyRateAnnexThree);
        } else if (this.showFiveDays()) {
          this.contract.weeklyFiveDaysMinimumSalaryAnThree = this.computeSalaryFromEffNumHours(
            this.contract.weeklyFiveDaysEffNumHours,
            this.contract.hourlyRateAnnexThree
          );
        } else if (this.showSixDays()) {
          this.contract.weeklySixDaysMinimumSalaryAnThree = this.computeSalaryFromEffNumHours(
            this.contract.weeklySixDaysEffNumHours,
            this.contract.hourlyRateAnnexThree
          );
        }
      }
      // this.manageStateErrorNumber(payload, '', 'hourlyRate')
    },
    computeNumEquivBaseHours(numHours) {
      // compute number of hours at regular hourlyRate to this combination of normal, ovt1, ovt2 and ovt3 hours
      let tmp = 0.1;
      // console.log("in computeNumEquivBaseHours numHours:", numHours);
      if (numHours > this.contract.weeklyOvtThreeLimit / 60) {
        tmp =
          this.contract.weeklyOvtOneLimit / 60 +
          (((this.contract.weeklyOvtTwoLimit - this.contract.weeklyOvtOneLimit) / 60) * this.contract.weeklyOvtOneRate) / 100 +
          (((this.contract.weeklyOvtThreeLimit - this.contract.weeklyOvtTwoLimit) / 60) * this.contract.weeklyOvtTwoRate) / 100 +
          ((numHours - this.contract.weeklyOvtThreeLimit / 60) * this.contract.weeklyOvtThreeRate) / 100;
      } else if (numHours > this.contract.weeklyOvtTwoLimit / 60) {
        tmp =
          this.contract.weeklyOvtOneLimit / 60 +
          (((this.contract.weeklyOvtTwoLimit - this.contract.weeklyOvtOneLimit) / 60) * this.contract.weeklyOvtOneRate) / 100 +
          ((numHours - this.contract.weeklyOvtTwoLimit / 60) * this.contract.weeklyOvtTwoRate) / 100;
      } else if (numHours > this.contract.weeklyOvtOneLimit / 60) {
        tmp = this.contract.weeklyOvtOneLimit / 60 + ((numHours - this.contract.weeklyOvtOneLimit / 60) * this.contract.weeklyOvtOneRate) / 100;
      } else {
        tmp = numHours;
      }
      // console.log("in computeNumEquivBaseHours:", tmp);
      return tmp;
    },
    computeHourlyRate(item) {
      // console.log("in computeHourlyRate:", item);
      let tmp = 1.0;
      if (this.showCCNAnnex1()) {
        if (this.showBaseDays()) {
          tmp = this.computeNumEquivBaseHours(this.contract.weeklyBaseEffNumHours);
        } else if (this.showFiveDays()) {
          tmp = this.computeNumEquivBaseHours(this.contract.weeklyFiveDaysEffNumHours);
        } else if (this.showSixDays()) {
          tmp = this.computeNumEquivBaseHours(this.contract.weeklySixDaysEffNumHours);
        }
        this.contract.hourlyRate = item / tmp;
        this.contract.hourlyRate = this.contract.hourlyRate.toFixed(10);
      }
    },
    showStandard() {
      return this.contract.timeManagementType === 0;
    },
    showCCNAnnex() {
      return this.contract.timeManagementType > 0 && this.contract.timeManagementType < 4;
    },
    showCCNAnnex1() {
      return this.contract.timeManagementType === 1;
    },
    showCCNAnnex3() {
      return this.contract.timeManagementType === 3;
    },
    showCCN2642CDICDD() {
      return this.contract.timeManagementType === 4;
    },
    showCCN2642CDDU() {
      return this.contract.timeManagementType === 5;
    },
    showSixDays() {
      return this.contract.workSixDays === 2;
    },
    showFiveDays() {
      return this.contract.workSixDays === 1;
    },
    showBaseDays() {
      return this.contract.workSixDays === 0;
    },
    showCNN2624DailyBase() {
      return this.contract.workSixDays === 10 || this.contract.workSixDays === 11;
    },
    showCNN2624WeeklyBase() {
      return this.contract.workSixDays === 12 || this.contract.workSixDays === 13;
    },
    showCNN2624MonthlyBase() {
      return this.contract.workSixDays === 14 || this.contract.workSixDays === 15;
    },
    validateFields(contract) {
      //console.log("in validate fields memodeal:",this.contract);
      contract.dailyRate = isNaN(parseFloat(contract.dailyRate)) ? 0 : parseFloat(contract.dailyRate);
      contract.travelDailyRate = isNaN(parseFloat(contract.travelDailyRate)) ? 0 : parseFloat(contract.travelDailyRate);
      contract.hourlyRate = isNaN(parseFloat(contract.hourlyRate)) ? 0 : parseFloat(contract.hourlyRate);
      contract.nightTimeRate = isNaN(parseFloat(contract.nightTimeRate)) ? 0 : parseFloat(contract.nightTimeRate);
      contract.hourBeforeTimeRate = isNaN(parseFloat(contract.hourBeforeTimeRate)) ? 0 : parseFloat(contract.hourBeforeTimeRate);
      contract.kmRate = isNaN(parseFloat(contract.kmRate)) ? 0 : parseFloat(contract.kmRate);
      contract.lunchPerDiem = isNaN(parseFloat(contract.lunchPerDiem)) ? 0 : parseFloat(contract.lunchPerDiem);
      contract.hotelPerDiem = isNaN(parseFloat(contract.hotelPerDiem)) ? 0 : parseFloat(contract.hotelPerDiem);
      contract.dailyRightTransfer = isNaN(parseFloat(contract.dailyRightTransfer)) ? 0 : parseFloat(contract.dailyRightTransfer);
      contract.lunchMinimum = isNaN(parseInt(contract.lunchMinimum)) ? 0 : parseInt(contract.lunchMinimum);
      contract.lunchMinimumForContDay = isNaN(parseInt(contract.lunchMinimumForContDay)) ? 0 : parseInt(contract.lunchMinimumForContDay);
      contract.sixthDay = isNaN(parseInt(contract.sixthDay)) ? 0 : parseInt(contract.sixthDay);
      contract.seventhDay = isNaN(parseInt(contract.seventhDay)) ? 0 : parseInt(contract.seventhDay);
      // contract.weeklyOvertime = contract.weeklyOvertime == 1 ? true : false
      contract.timeManagementType = isNaN(parseInt(contract.timeManagementType)) ? 0 : parseInt(contract.timeManagementType);
      contract.overtimeRate = isNaN(parseFloat(contract.overtimeRate)) ? 0 : parseFloat(contract.overtimeRate);
      contract.weeklyFiveDaysMinimumSalary = isNaN(parseFloat(contract.weeklyFiveDaysMinimumSalary)) ? 0 : parseFloat(contract.weeklyFiveDaysMinimumSalary);
      contract.weeklySixDaysMinimumSalary = isNaN(parseFloat(contract.weeklySixDaysMinimumSalary)) ? 0 : parseFloat(contract.weeklySixDaysMinimumSalary);
      contract.weeklyFiveDaysEffNumHours = isNaN(parseFloat(contract.weeklyFiveDaysEffNumHours)) ? 0 : parseFloat(contract.weeklyFiveDaysEffNumHours);
      contract.weeklyFiveDaysEquNumHours = isNaN(parseFloat(contract.weeklyFiveDaysEquNumHours)) ? 0 : parseFloat(contract.weeklyFiveDaysEquNumHours);
      contract.weeklySixDaysEffNumHours = isNaN(parseFloat(contract.weeklySixDaysEffNumHours)) ? 0 : parseFloat(contract.weeklySixDaysEffNumHours);
      contract.weeklySixDaysEquNumHours = isNaN(parseFloat(contract.weeklySixDaysEquNumHours)) ? 0 : parseFloat(contract.weeklySixDaysEquNumHours);
      contract.weeklyBonusAmount = isNaN(parseFloat(contract.weeklyBonusAmount)) ? 0 : parseFloat(contract.weeklyBonusAmount);
      contract.weeklyFiveDaysRefSalary = isNaN(parseFloat(contract.weeklyFiveDaysRefSalary)) ? 0 : parseFloat(contract.weeklyFiveDaysRefSalary);
      contract.weeklySixDaysRefSalary = isNaN(parseFloat(contract.weeklySixDaysRefSalary)) ? 0 : parseFloat(contract.weeklySixDaysRefSalary);
      contract.weeklyOvtOneLimit = isNaN(parseFloat(contract.weeklyOvtOneLimit)) ? 0 : parseFloat(contract.weeklyOvtOneLimit);
      contract.weeklyOvtOneRate = isNaN(parseFloat(contract.weeklyOvtOneRate)) ? 0 : parseFloat(contract.weeklyOvtOneRate);
      contract.weeklyOvtTwoLimit = isNaN(parseFloat(contract.weeklyOvtTwoLimit)) ? 0 : parseFloat(contract.weeklyOvtTwoLimit);
      contract.weeklyOvtTwoRate = isNaN(parseFloat(contract.weeklyOvtTwoRate)) ? 0 : parseFloat(contract.weeklyOvtTwoRate);
      contract.weeklyOvtThreeLimit = isNaN(parseFloat(contract.weeklyOvtThreeLimit)) ? 0 : parseFloat(contract.weeklyOvtThreeLimit);
      contract.weeklyOvtThreeRate = isNaN(parseFloat(contract.weeklyOvtThreeRate)) ? 0 : parseFloat(contract.weeklyOvtThreeRate);
      contract.weeklyBaseEffNumHours = isNaN(parseFloat(contract.weeklyBaseEffNumHours)) ? 0 : parseFloat(contract.weeklyBaseEffNumHours);
      contract.hourlyRateAnnexThree = isNaN(parseFloat(contract.hourlyRateAnnexThree)) ? 0 : parseFloat(contract.hourlyRateAnnexThree);
      contract.weeklyBonusAmountFiveDays = isNaN(parseFloat(contract.weeklyBonusAmountFiveDays)) ? 0 : parseFloat(contract.weeklyBonusAmountFiveDays);
      contract.weeklyBonusAmountSixDays = isNaN(parseFloat(contract.weeklyBonusAmountSixDays)) ? 0 : parseFloat(contract.weeklyBonusAmountSixDays);
      contract.weeklyBaseRefSalary = isNaN(parseFloat(contract.weeklyBaseRefSalary)) ? 0 : parseFloat(contract.weeklyBaseRefSalary);
      contract.weeklyBaseMinimumSalary = isNaN(parseFloat(contract.weeklyBaseMinimumSalary)) ? 0 : parseFloat(contract.weeklyBaseMinimumSalary);
      contract.weeklyFiveDaysMinimumSalaryAnThree = isNaN(parseFloat(contract.weeklyFiveDaysMinimumSalaryAnThree))
        ? 0
        : parseFloat(contract.weeklyFiveDaysMinimumSalaryAnThree);
      contract.weeklySixDaysMinimumSalaryAnThree = isNaN(parseFloat(contract.weeklySixDaysMinimumSalaryAnThree))
        ? 0
        : parseFloat(contract.weeklySixDaysMinimumSalaryAnThree);
      contract.transportRate = isNaN(parseFloat(contract.transportRate)) ? 0 : parseFloat(contract.transportRate);
      contract.ovtRate1 = isNaN(parseFloat(contract.ovtRate1)) ? 0 : parseFloat(contract.ovtRate1);
      contract.ovtRate2 = isNaN(parseFloat(contract.ovtRate2)) ? 0 : parseFloat(contract.ovtRate2);
      contract.sundayPublicHolidayFactor = isNaN(parseFloat(contract.sundayPublicHolidayFactor)) ? 0 : parseFloat(contract.sundayPublicHolidayFactor);
      contract.companyCostFactor = isNaN(parseFloat(contract.companyCostFactor)) ? 1 : parseFloat(contract.companyCostFactor);
      contract.transportPaidAfter = isNaN(parseInt(contract.transportPaidAfter)) ? 0 : parseInt(contract.transportPaidAfter);
      contract.ovtLimit1 = isNaN(parseInt(contract.ovtLimit1)) ? 0 : parseInt(contract.ovtLimit1);
      contract.ovtLimit2 = isNaN(parseInt(contract.ovtLimit2)) ? 0 : parseInt(contract.ovtLimit2);
      contract.minTimeBetweenWeek = isNaN(parseInt(contract.minTimeBetweenWeek)) ? 0 : parseInt(contract.minTimeBetweenWeek);
      contract.beforeCallTimeRate = isNaN(parseFloat(contract.beforeCallTimeRate)) ? 0 : parseFloat(contract.beforeCallTimeRate);
      contract.carAllowance = isNaN(parseFloat(contract.carAllowance)) ? 0 : parseFloat(contract.carAllowance);
      contract.phoneAllowance = isNaN(parseFloat(contract.phoneAllowance)) ? 0 : parseFloat(contract.phoneAllowance);
      contract.computerAllowance = isNaN(parseFloat(contract.computerAllowance)) ? 0 : parseFloat(contract.computerAllowance);
      contract.boxKitAllowance = isNaN(parseFloat(contract.boxKitAllowance)) ? 0 : parseFloat(contract.boxKitAllowance);
      contract.productionFeeAllowance = isNaN(parseFloat(contract.productionFeeAllowance)) ? 0 : parseFloat(contract.productionFeeAllowance);
      contract.dinnerPerDiem = isNaN(parseFloat(contract.dinnerPerDiem)) ? 0 : parseFloat(contract.dinnerPerDiem);
      contract.abroadPerDiem = isNaN(parseFloat(contract.abroadPerDiem)) ? 0 : parseFloat(contract.abroadPerDiem);
      contract.cdiMonthlyReferenceSalary = isNaN(parseFloat(contract.cdiMonthlyReferenceSalary)) ? 0 : parseFloat(contract.cdiMonthlyReferenceSalary);

      return contract;
    },
    isEditable() {
      return !this.disableEdit;
    },
    loadEditDataToContract() {
      //console.log("loadEditDataToContract this.editData:",this.editData);
      if (!isNil(this.editData)) {
        //  console.log("editData:", this.editData);
        this.contract = {
          ...this.contract,
          ...this.editData
        };
      }

      this.computeSMG();
      //console.log("in loadEditDataToContract this.contract:",this.contract);
    },
    copyContract() {
      this.contractContent = this.contract;

      const omitKeys = ['costCenterPrepsType', 'costCenterShootingType', 'costCenterWrapType'];
      this.contractContent = {
        ...omit(omitKeys, this.contractContent)
      };

      this.contractCopied = 1;

      this.createToastForMobile(this.FormMSG(195, 'Success'), this.FormMSG(196, 'Your deal memo was copied successfully, you can do your paste'), '');

      return;
    },
    pasteContract() {
      this.contract = this.contractContent;

      this.createToastForMobile(this.FormMSG(195, 'Success'), this.FormMSG(197, 'Paste deal memo done successfully'), '');

      return;
    },
    disablePaste() {
      return !this.contractCopied;
    },
    updateNightStart(payload) {
      this.contract.nightTimeStart = `${payload.target.value}:00`;
    },
    updateNightEnd(payload) {
      this.contract.nightTimeEnd = `${payload.target.value}:00`;
    },
    updateMinTimeBetweenDays(payload) {
      this.contract.minTimeBetweenDays = `${payload.target.value}:00`;
    },
    handleClickHeader(key) {
      this.configAccordion[key].isVisible = !this.configAccordion[key].isVisible;
      // console.log({data});
    },
    async handleManagementType(payload) {
      this.$emit('memo-deal:fields:clear-error', true);

      if (this.showCCN2642CDDU()) {
        if (this.contract.workSixDays === 0) {
          this.contract.workSixDays = 12;
        }
      } else {
        if (this.contract.workSixDays >= 10) {
          this.contract.workSixDays = 0;
        }
      }
      if (payload === 4) {
        const ccn2642 = await this.getCcn2642DefaultData(payload, this.contract.cdiMonthlyReferenceSalary);
        this.contract.hourlyRate = ccn2642.hourlyRate;
        this.contract.dailyRate = ccn2642.dailyRate;
        this.contract.monthlyRate = ccn2642.monthlyRate;
        this.contract.totMinPerDayStr = ccn2642.totMinPerDayStr === '' ? '00:00' : ccn2642.totMinPerDayStr;
        this.contract.totMinPerWeekStr = ccn2642.totMinPerDayStr === '' ? '00:00' : ccn2642.totMinPerWeekStr;
      } else if (payload === 5) {
        const ccn2642 = await this.getCcn2642DefaultData(payload, this.contract.weeklyFiveDaysRefSalary, this.contract.workSixDays);
        this.setDefaultValueCcn2642(ccn2642);
      }
      if (!_.isNil(this.contract.departmentId) && !_.isNil(this.contract.functionId)) {
        this.$emit('memo-deal:department-function:required', false);
      } else {
        this.$emit('memo-deal:department-function:required', true);
      }
    },
    async handleCcn2642(payload) {
      let ccn2642;
      if (this.cloneWeeklyFiveDaysRefSalaryWithDecimal === null) {
        ccn2642 = await this.getCcn2642DefaultData(this.contract.timeManagementType, this.contract.weeklyFiveDaysRefSalary, payload);
      } else {
        ccn2642 = await this.getCcn2642DefaultData(this.contract.timeManagementType, this.cloneWeeklyFiveDaysRefSalaryWithDecimal, payload);
      }
      this.setDefaultValueCcn2642(ccn2642);
      if (!_.isNil(this.contract.departmentId) && !_.isNil(this.contract.functionId)) {
        this.$emit('memo-deal:department-function:required', false);
      } else {
        this.$emit('memo-deal:department-function:required', true);
      }
    },
    setDefaultValueCcn2642(ccn2642) {
      if (this.showCNN2624DailyBase()) {
        this.contract.hourlyRate = ccn2642.hourlyRate;
        this.contract.dailyRate = ccn2642.dailyRate;
        this.contract.totMinPerDayStr = ccn2642.totMinPerDayStr === '' ? '00:00' : ccn2642.totMinPerDayStr;
        //
        this.contract.weeklyFiveDaysMinimumSalary = 0;
        this.contract.totMinPerWeekStr = '00:00';
        this.contract.monthlyRate = 0;
      } else if (this.showCNN2624WeeklyBase()) {
        this.contract.hourlyRate = ccn2642.hourlyRate;
        this.contract.dailyRate = ccn2642.dailyRate;
        this.contract.totMinPerDayStr = ccn2642.totMinPerDayStr === '' ? '00:00' : ccn2642.totMinPerDayStr;
        this.contract.weeklyFiveDaysMinimumSalary = ccn2642.weeklyFiveDayMinmumSalary;
        this.contract.totMinPerWeekStr = ccn2642.totMinPerDayStr === '' ? '00:00' : ccn2642.totMinPerWeekStr;
        //
        this.contract.monthlyRate = 0;
      } else if (this.showCNN2624MonthlyBase()) {
        this.contract.hourlyRate = ccn2642.hourlyRate;
        this.contract.dailyRate = ccn2642.dailyRate;
        this.contract.totMinPerDayStr = ccn2642.totMinPerDayStr === '' ? '00:00' : ccn2642.totMinPerDayStr;
        this.contract.weeklyFiveDaysMinimumSalary = ccn2642.weeklyFiveDayMinmumSalary;
        this.contract.totMinPerWeekStr = ccn2642.totMinPerDayStr === '' ? '00:00' : ccn2642.totMinPerWeekStr;
        this.contract.monthlyRate = ccn2642.monthlyRate;
      }
    },
    async getCcn2642DefaultData(typeManagement, refSalary, workSixDay = null) {
      return await dataCcn2642(typeManagement, refSalary, workSixDay);
    },
    async saveAsDealMemoTemplate(e) {
      this.$emit('memo-deal:save-template', e);
    },
    calculateAverageRate(rate, percent) {
      return !isNaN(rate) && !isNaN(percent) && rate > 0 && percent > 0 ? (rate * (percent / 100)).toFixed(2) : 0;
    },
    handleAccessGeneralAllowance(event, model) {
      // const oldValue = ; // @TODO : to fill with copy
      if (!event) {
        this.contract[model] = 0;
      }
    },
    getStandardPayCodeTitle(payload) {
      const options = this.FormMenu(1010);
      let menu = options.filter((item) => payload === item.value);
      menu = menu.length > 0 ? menu[0].text : '';
      menu = menu.substring(0, menu.lastIndexOf('(') - 1).trim();

      this.standardPayCodeTitle = this.FormMSG(313, 'Pay code') + ' ' + menu.toLowerCase();
      // this.showDefaultPayCode = this.showStandard() && this.showPayCode;
    },
    setPayroolCodeValue(payload, fieldName) {
      this.contract[fieldName] = +payload;
    },
    resetPayroolCodeValue(payload, fieldName) {
      if (payload) {
        this.contract[fieldName] = null;
      }
    },
    generateTextId(id) {
      return generateSecureId(id);
    },
    async handleWeeklyRefSalary() {
      if (typeof this.contract.weeklyFiveDaysRefSalary === 'string' && this.contract.weeklyFiveDaysRefSalary.match(',')) {
        this.cloneWeeklyFiveDaysRefSalary = _.concat(this.contract.weeklyFiveDaysRefSalary.replace(',', '.'));
        await new Promise((resolve, reject) => {
          setTimeout(async () => {
            resolve(await this.handleChangeOfRefSalary(this.cloneWeeklyFiveDaysRefSalary[0], false));
            reject(false);
          }, 1000);
        });
      } else {
        await new Promise((resolve, reject) => {
          setTimeout(async () => {
            resolve(await this.handleChangeOfRefSalary(this.contract.weeklyFiveDaysRefSalary, false));
            reject(false);
          }, 1000);
        });
      }
    },
    async handleMonthlyRefSalary() {
      await new Promise((resolve, reject) => {
        setTimeout(async () => {
          resolve(await this.handleChangeOfRefSalary(this.contract.cdiMonthlyReferenceSalary, true));
          reject(false);
        }, 1000);
      });
    },
    async handleChangeOfRefSalary(refSalary, isMonthly = true) {
      const ccn2642 = await this.getCcn2642DefaultData(this.contract.timeManagementType, refSalary, isMonthly ? null : this.contract.workSixDays);

      // console.log({ ccn2642 });
      this.contract.hourlyRate = ccn2642.hourlyRate;
      this.contract.dailyRate = ccn2642.dailyRate;
      this.contract.monthlyRate = ccn2642.monthlyRate;
      this.contract.totMinPerDay = ccn2642.totMinPerDay;
      this.contract.totMinPerDayStr = ccn2642.totMinPerDayStr;
      this.contract.weeklyFiveDaysMinimumSalary = ccn2642.weeklyFiveDayMinmumSalary;
      this.contract.weeklyFiveDaysRefSalary = this.contract.weeklyFiveDaysRefSalary;
      this.contract.totMinPerWeek = ccn2642.totMinPerWeek;
      this.contract.totMinPerWeekStr = ccn2642.totMinPerWeekStr;
      this.contract.cdiMonthlyReferenceSalary = ccn2642.cdiMonthlyReferenceSalary;
      this.cloneWeeklyFiveDaysRefSalaryWithDecimal = ccn2642.weeklyFiveDaysRefSalary;
    },
    async getPublicHolidays() {
      const result = await getProjectPublicHolidayCalendar(true);
      if (result) {
        this.publicHolidays = result.map((option) => ({
          value: option.calNumber,
          text: option.name
        }));
      }
    },
    async customFieldList() {
      let items = await getCustomFields({ type: this.defaultCustomFieldParentType, contractId: +this.contract.id, xid: this.contract.userRequestXid });

      return items.map((item, index) => {
        const prefixModel = 'custom-field-model-',
          prefixNameGroup = 'custom-field-name-group-';
        const model = generateSecureId(prefixModel + item.id);
        const nameGroup = generateSecureId(prefixNameGroup + item.id);
        const customFieldValues = item.customFieldValues;
        let value = null,
          ids = null;

        switch (+item.type) {
          case CUSTOM_FIELD_TYPE.Checkbox:
            value = [];
            if (customFieldValues.length > 0) {
              ids = [];
              for (const customFieldValue of customFieldValues) {
                ids.push(+customFieldValue.customFieldMenuChoiceValue);
              }
              value = ids;
            }

            break;
          case CUSTOM_FIELD_TYPE.Date:
            // value = moment().format('YYYY-MM-DD');
            value = null;
            if (customFieldValues.length > 0) {
              value = moment(customFieldValues[0].value).format('YYYY-MM-DD');
            }

            break;
          case CUSTOM_FIELD_TYPE.Dropdown:
            value = null;
            if (customFieldValues.length > 0) {
              value = customFieldValues[0].customFieldMenuChoiceValue.toString();
            }

            break;
          case CUSTOM_FIELD_TYPE.Freetext:
            value = null;
            if (customFieldValues.length > 0) {
              value = customFieldValues[0].value;
            }

            break;
          case CUSTOM_FIELD_TYPE.Number:
            value = 0;
            if (customFieldValues.length > 0) {
              value = customFieldValues[0].value;
            }

            break;
          case CUSTOM_FIELD_TYPE.Percentage:
            value = 0;
            if (customFieldValues.length > 0) {
              value = customFieldValues[0].value;
            }

            break;
          case CUSTOM_FIELD_TYPE.Radiobutton:
            value = null;
            if (customFieldValues.length > 0) {
              value = +customFieldValues[0].customFieldMenuChoiceValue;
            }

            break;
        }

        this.customFieldModels[index] = model;

        if (this.isEditable() === false) {
          item.disabled = true;
        }

        item = {
          ...item,
          [model]: value,
          nameGroup
        };

        return item;
      });
    },
    sizeFlagInput(length) {
      let size = 4;

      if (length >= 4) {
        size = 3;
      }

      return size;
    },
    manageCustomFields() {
      this.isCustomFieldModalOpen = true;
    },
    onCustomFieldMainModalClosed() {
      this.isCustomFieldModalOpen = false;
    },
    async onCustomFieldMainModalReloaded() {
      this.customFields = await this.customFieldList();
    },
    onFieldTemplateChanged(payload) {
      // console.log({ userRequestPayload: payload });
      const findIndex = this.customFieldValueInputs.findIndex((customFieldValue) => +customFieldValue.index === +payload.index);
      let value = null;

      if (payload.type === CUSTOM_FIELD_TYPE.Checkbox) {
        value = payload[this.customFieldModels[payload.index]].join(',');
      } else {
        value = payload[this.customFieldModels[payload.index]].toString();
      }

      const customFieldValue = {
        index: payload.index,
        userId: +this.userId,
        customFieldId: +payload.customFieldId,
        value
        // customFieldValueId: 0
      };

      if (findIndex === -1) {
        this.customFieldValueInputs.push(customFieldValue);
      } else {
        this.customFieldValueInputs[findIndex] = {
          ...this.customFieldValueInputs[findIndex],
          ...customFieldValue
        };
      }
      // console.log({ userRequestCustomFieldValueInputs: this.userRequestCustomFieldValueInputs });
      this.$emit('memo-deal:user-custom-field-value', this.customFieldValueInputs);

      this.customFields = this.customFields.map((customField, index) => {
        if (+customField.id === +payload.id) {
          customField = {
            ...payload
          };
        }

        return customField;
      });
    },
    onHandledNumber({ model, payload }) {
      let self = this;
      const models = model.split('.');

      if (models.length > 0) {
        for (let i = 0; i < models.length - 1; i++) {
          self = self[models[i]];
        }
        self[models[models.length - 1]] = payload;
      } else {
        self[model] = payload;
      }
    }
  }
};
</script>
<style scoped></style>
